<template>
    <panel-navigation>
            <rate-lead-modal ref="RateLeadModal"></rate-lead-modal>
            <dialog-request-review ref="dialogRequestReview"></dialog-request-review>

            <div v-if="showFullLeadDetailsMobile" @click.self="showFullLeadDetailsMobile = false" :key="showFullLeadDetailsMobileKey" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="p-6" style="position: relative; height: calc(100% - 20px); overflow: auto;">

                        <div style="clear: both;"></div>

                        <div>
                            <div v-show="leadDetailsMobile.lead_id" style="float: right;">
                                <strong>Lead ID:</strong> {{ leadDetailsMobile.lead_id }}
                            </div>

                            <span :style="((leadDetailsMobile.archived == 1) ? 'text-decoration: line-through;' : '')">{{ leadDetailsMobile.customer_phone_number }}</span>

                            <div style="clear: both;"></div>

                            <br clear="all" />

                            <div class="flex leadDetailsMobiles-center gap-2">
                                <div class="flex leadDetailsMobiles-center gap-2">
                                    <v-tooltip v-for="p in normalizedProviders(leadDetailsMobile)" :key="p.key" top color="primary">
                                    <template #activator="{ on, attrs }">
                                    <img
                                    v-bind="attrs"
                                    v-on="on"
                                    :src="p.src"
                                    :alt="p.title"
                                    class="rg-channel-icon"
                                    @click="p.onClick && p.onClick(leadDetailsMobile)"
                                    :style="((me && me.is_medical) ? 'cursor: initial;' : 'cursor: pointer;') + ((p.title == 'AI' || p.title == 'Web Chat') ? 'width: 52px; height: 52px; margin-left: -10px; margin-top: -13px;' : '')"
                                    />
                                    </template>
                                    <span>{{ p.title }}</span>
                                    </v-tooltip>
                                </div>


                                <!-- Modality chip (Call / Message / Booking) -->
                                <span class="inline-flex leadDetailsMobiles-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-slate-300 ml-1" style="background-color: #CCCCCC; height: 16px;">
                                <i v-if="leadDetailsMobile.lead_type == 'PHONE_CALL'" class="mdi mdi-phone"></i>
                                <i v-else-if="leadDetailsMobile.lead_type == 'MESSAGE'" class="mdi mdi-message-text-outline"></i>
                                <i v-else-if="leadDetailsMobile.sources == 'web'" class="mdi mdi-chat"></i>
                                <i v-else class="mdi mdi-information-outline"></i>
                                <span v-if="leadDetailsMobile.lead_type == 'PHONE_CALL'">Call</span>
                                <span v-else-if="leadDetailsMobile.sources == 'web'">CHAT</span>
                                <span v-else-if="leadDetailsMobile.lead_type == 'MESSAGE'">Message</span>
                                <span v-else-if="leadDetailsMobile.lead_type == 'BOOKING'">Booking</span>
                                <span v-else>-</span>
                                </span>
                            </div>

                            <div style="line-height: 28px;">
                                <strong>AI Number:</strong> {{ leadDetailsMobile.to || "-" }}

                                <br />

                                <strong>Category:</strong>
                                
                                <span v-if="leadDetailsMobile.lead_category">
                                    {{ leadDetailsMobile.lead_category.replace(/\_/g, " ") }}
                                </span>

                                <span v-if="!leadDetailsMobile.lead_category">
                                    N/A
                                </span>

                                <br />

                                <strong>Lead Creation Date:</strong> {{ displayTimestamp(leadDetailsMobile.lead_creation_date) }}

                                <br />

                                <strong>Last Updated:</strong> {{ displayTimestamp(leadDetailsMobile.updated_at) }}

                                <br />

                                <strong>Response Time:</strong>

                                <span v-if="leadDetailsMobile.responded_time !== NULL && leadDetailsMobile.responded_time !== -1">
                                    <span v-if="leadDetailsMobile.responded_time > 1000">
                                        {{ parseInt(leadDetailsMobile.responded_time / 60) }} minutes
                                    </span>
                                    <span v-else>
                                        {{ leadDetailsMobile.responded_time }} seconds
                                    </span>
                                </span>
                                <span v-else>N/A</span>

                                <br />

                                <strong>Location:</strong> 

                                <span v-if="leadDetailsMobile.geo">
                                    {{ leadDetailsMobile.geo.split(',')[0] }}
                                </span>
                                <span v-else>
                                    N/A
                                </span>

                                <br />

                                <strong>Job Type:</strong> 

                                <span v-if="leadDetailsMobile.job_type">
                                    {{ leadDetailsMobile.job_type.replace(/\_/g, " ").toLowerCase().replace(/\b[a-z]/g, function(letter) { return letter.toUpperCase(); }) }}
                                </span>
                                <span v-else>
                                    N/A
                                </span>

                                <br />

                                <strong>Value:</strong>

                                <div :class="'lsa-show-value lsa-show-value-' + leadDetailsMobile.id">
                                    <a href="javascript: void(0);" @click="showEditValue(leadDetailsMobile)">${{ leadDetailsMobile.value }}<i v-show="$store.state.auth.owner" class="mdi mdi-pencil-outline ml-2"></i></a>
                                </div>
                                <div :class="'lsa-edit-value lsa-edit-value-' + leadDetailsMobile.id" style="display: none; position: relative; width: 150px;">
                                    <input type="text" :value="((leadDetailsMobile.value > 0) ? leadDetailsMobile.value : me.settings.customer_value)" style="padding: 5px; border: solid 1px #CCCCCC; width: 100px;" />
                                    <div style="position: absolute; margin-top: -22px; right: -31px;">
                                        <a href="javascript: void(0);" style="color: #3EBB80 !important;" @click="editValue(leadDetailsMobile)"><i class="mdi mdi-check"></i></a>
                                        <a href="javascript: void(0);" class="" style="color: #E53F71 !important;" @click="cancelEditValue(leadDetailsMobile)"><i class="mdi mdi-close"></i></a>
                                    </div>
                                    <div style="clear: both;"></div>
                                </div>

                                <strong>Tags:</strong>

                                <div class="pt-2 pb-2">
                                    <span v-for="(tag, index_tag) in leadDetailsMobile.tag" :key="'tag-' + index_tag" class="pr-2 pb-2">
                                        <v-chip v-if="tag == 0" class="mb-1 dark">
                                            <span style="font-size: 12px;">Not Set</span>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 1" color="#3EBB80">
                                            <span style="font-size: 12px; color: #FFFFFF;">Existing Customer</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 2" color="#44468F">
                                            <span style="font-size: 12px; color: #FFFFFF;">Missed Call</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 3" color="#FFB443" v-show="!isOnlyAi()">
                                            <span style="font-size: 12px; color: #FFFFFF;">Opportunity</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 4" color="#2477F6" v-show="!isOnlyAi()">
                                            <span style="font-size: 12px; color: #FFFFFF;">Meeting Scheduled</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 5" color="#E53F71">
                                            <span style="font-size: 12px; color: #FFFFFF;">Became Customer</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 'Signed'" color="#2137cb" v-show="!isOnlyAi()">
                                            <span style="font-size: 12px; color: #FFFFFF;">Signed</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 'Booked for Consultation'" color="#2bce7f" v-show="!isOnlyAi()">
                                            <span style="font-size: 12px; color: #FFFFFF;">Booked for Consultation</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 'Declined/Not a lead'" color="#aa242b" v-show="!isOnlyAi()">
                                            <span style="font-size: 12px; color: #FFFFFF;">Declined/Not a lead</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 'Wrong Number'" color="#de2f4d" v-show="!isOnlyAi()">
                                            <span style="font-size: 12px; color: #FFFFFF;">Wrong Number</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 'Auto Credited'" color="#338108" v-show="!isOnlyAi()">
                                            <span style="font-size: 12px; color: #FFFFFF;">Auto Credited</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 'No Response'" color="#3f3f3f" v-show="!isOnlyAi()">
                                            <span style="font-size: 12px; color: #FFFFFF;">No Response</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 'Existing Client'" color="#4ad25a" v-show="!isOnlyAi()">
                                            <span style="font-size: 12px; color: #FFFFFF;">Existing Client</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 'Failed Sign Up'" color="#830934" v-show="!isOnlyAi()">
                                            <span style="font-size: 12px; color: #FFFFFF;">Failed Sign Up</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 'Following Up/Working on this one'" color="#9418af" v-show="!isOnlyAi()">
                                            <span style="font-size: 12px; color: #FFFFFF;">Following Up/Working on this one</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 'E-Doc sent not signed'" color="#5a3a69" v-show="!isOnlyAi()">
                                            <span style="font-size: 12px; color: #FFFFFF;">E-Doc sent not signed</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 'Booked to Service'" color="#2bce7f" v-show="!isOnlyAi()">
                                            <span style="font-size: 12px; color: #FFFFFF;">Booked to Service</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 'Booked for Appointment'" color="#1921ba" v-show="!isOnlyAi()">
                                            <span style="font-size: 12px; color: #FFFFFF;">Booked for Appointment</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 'Cancelled'" color="#c6ab24">
                                            <span style="font-size: 12px; color: #FFFFFF;">Cancelled</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 'Complete'" color="#1921ba">
                                            <span style="font-size: 12px; color: #FFFFFF;">Complete</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 'Incomplete'" color="#c6ab24">
                                            <span style="font-size: 12px; color: #FFFFFF;">Incomplete</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 'AI Test Call'" color="#000000">
                                            <span style="font-size: 12px; color: #FFFFFF;">AI Test Call</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag == 'Duplicate Call'" color="#6750D7">
                                            <span style="font-size: 12px; color: #FFFFFF;">Duplicate Call</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(leadDetailsMobile, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>

                                        <v-chip class="mb-1" v-if="tag != 0 && tag != 1 && tag != 2 && tag != 3 && tag != 4 && tag != 5
                                            && tag != 'Signed'
                                            && tag != 'Booked for Consultation'
                                            && tag != 'Declined/Not a lead'
                                            && tag != 'Wrong Number'
                                            && tag != 'Auto Credited'
                                            && tag != 'No Response'
                                            && tag != 'Existing Client'
                                            && tag != 'Failed Sign Up'
                                            && tag != 'Following Up/Working on this one'
                                            && tag != 'E-Doc sent not signed'
                                            && tag != 'Booked to Service'
                                            && tag != 'Booked for Appointment'
                                            && tag != 'Cancelled'
                                            && tag != 'Complete'
                                            && tag != 'Incomplete'
                                            && tag != 'AI Test Call'
                                            && tag != 'Duplicate Call'
                                        
                                        " :color="getCustomTagColor(tag)">
                                            <span style="font-size: 12px; color: #FFFFFF;">{{ tag }}</span>

                                            <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                        </v-chip>
                                    </span>
                                </div>

                                <v-menu
                                        bottom
                                        right

                                        nudge-bottom='25'
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" color="green" v-bind="attrs" v-on="on" :ripple="false" small class="ml-1">mdi-plus</v-icon>
                                    </template>

                                    <v-list class="table-menu-actions p-2" style="max-height: 500px; overflow-y: auto;">
                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #44468F;" @click="setTag(leadDetailsMobile, 2);">Missed Call</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #FFB443;" @click="setTag(leadDetailsMobile, 3);">Opportunity</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #2477F6;" @click="setTag(leadDetailsMobile, 4);">Meeting Scheduled</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #E53F71;" @click="setTag(leadDetailsMobile, 5);">Became Customer</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #3EBB80;" @click="setTag(leadDetailsMobile, 1);">Existing Customer</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #2137cb;" @click="setTag(leadDetailsMobile, 'Signed');">Signed</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #2bce7f;" @click="setTag(leadDetailsMobile, 'Booked for Consultation');">Booked for Consultation</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #aa242b;" @click="setTag(leadDetailsMobile, 'Declined/Not a lead');">Declined/Not a lead</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #de2f4d;" @click="setTag(leadDetailsMobile, 'Wrong Number');">Wrong Number</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #338108;" @click="setTag(leadDetailsMobile, 'Auto Credited');">Auto Credited</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #3f3f3f;" @click="setTag(leadDetailsMobile, 'No Response');">No Response</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #4ad25a;" @click="setTag(leadDetailsMobile, 'Existing Client');">Existing Client</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #830934;" @click="setTag(leadDetailsMobile, 'Failed Sign Up');">Failed Sign Up</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #9418af;" @click="setTag(leadDetailsMobile, 'Following Up/Working on this one');">Following Up/Working on this one</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #5a3a69;" @click="setTag(leadDetailsMobile, 'E-Doc sent not signed');">E-Doc sent not signed</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #2bce7f;" @click="setTag(leadDetailsMobile, 'Booked to Service');">Booked to Service</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #1921ba;" @click="setTag(leadDetailsMobile, 'Booked for Appointment');">Booked for Appointment</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #c6ab24;" @click="setTag(leadDetailsMobile, 'Cancelled');">Cancelled</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #1921ba;" @click="setTag(leadDetailsMobile, 'Complete');">Complete</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #c6ab24;" @click="setTag(leadDetailsMobile, 'Incomplete');">Incomplete</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #000000;" @click="setTag(leadDetailsMobile, 'AI Test Call');">AI Test Call</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #6750D7;" @click="setTag(leadDetailsMobile, 'Duplicate Call');">Duplicate Call</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item v-for="(custom_tag, tag_index) in custom_tags" :key="'custom-tag-' + tag_index" class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" :style="'color: ' + custom_tag.color + ';'" @click="setTag(leadDetailsMobile, custom_tag.tag);">{{ custom_tag.tag }}</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);" @click="showAddTag = true">+ Add Tag</a></v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>

                                <br />

                                <strong>Status:</strong><br />
                                <v-chip
                                        small
                                        color="gray lighten-5"
                                        text-color="gray lighten-1"
                                    
                                        v-if="leadDetailsMobile.qualify_status == 0"
                                >
                                    Not Set
                                </v-chip>

                                <v-chip
                                        small
                                        color="green lighten-5"
                                        text-color="green lighten-1"
                                    
                                        v-if="leadDetailsMobile.qualify_status == 1"
                                >
                                    Qualified
                                </v-chip>

                                <v-chip
                                        small
                                        color="red lighten-5"
                                        text-color="red lighten-1"
                                    
                                        v-if="leadDetailsMobile.qualify_status == -1"
                                >
                                    Unqualified
                                </v-chip>

                                <v-chip
                                        small
                                        color="red darken-2"
                                        text-color="white"
                                    
                                        v-if="leadDetailsMobile.qualify_status == 2"
                                >
                                    Spam
                                </v-chip>

                                <v-chip v-if="leadDetailsMobile.qualify_status != 0 && leadDetailsMobile.qualify_status != 1 && leadDetailsMobile.qualify_status != 2 && leadDetailsMobile.qualify_status != -1" :color="getCustomStatusColor(leadDetailsMobile.qualify_status)"
                                    small
                                    text-color="white"
                                >
                                    {{ leadDetailsMobile.qualify_status }}
                                </v-chip>

                                <v-menu

                                    

                                        bottom
                                        right

                                        nudge-bottom='25'
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" color="green" v-bind="attrs" v-on="on" :ripple="false" small class="ml-1">mdi-plus</v-icon>
                                    </template>

                                    <v-list class="table-menu-actions">
                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);" @click="leadDetailsMobile.qualify_status = 1; setQualifyStatus(leadDetailsMobile, 1);">Qualified</a>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);" @click="leadDetailsMobile.qualify_status = -1; setQualifyStatus(leadDetailsMobile, -1);">Unqualified</a>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);" @click="leadDetailsMobile.qualify_status = 2; setQualifyStatus(leadDetailsMobile, 2);">Spam</a>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);" @click="leadDetailsMobile.qualify_status = 0; setQualifyStatus(leadDetailsMobile, 0);">Not Set</a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item v-for="(custom_status, status_index) in custom_statuses" :key="'custom-status-' + status_index" class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" :style="'color: ' + custom_status.color + ';'" @click="leadDetailsMobile.qualify_status = custom_status.status; setQualifyStatus(leadDetailsMobile, custom_status.status);">{{ custom_status.status }}</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);" @click="showAddStatus = true">+ Add Status</a></v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>

                                <br />

                                <strong>Notes:</strong><br />
                                <div style="position: relative;">

                                    <a href="javascript: void(0);" @click="notes_lead = leadDetailsMobile; show_notes_dialog = true"><i class="mdi mdi-comment-multiple-outline" style="font-size: 24px !important;"></i></a>

                                    <span v-if="leadDetailsMobile.notes.length > 0" style="width: 16px;
                                        height: 16px;
                                        line-height: 17px;
                                        font-size: 10px;
                                        background: rgb(255, 112, 67);
                                        color: rgb(255, 255, 255);
                                        padding: 0px !important;
                                        border-radius: 100%;
                                        position: absolute;
                                        font-weight: 600;
                                        text-align: center;
                                        margin-top: -3px;
                                        margin-left: -6px;">{{ leadDetailsMobile.notes.length }}</span>
                                </div>

                            </div>

                        </div>
                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                        <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showFullLeadDetailsMobile = false">
                            CLOSE
                        </button>

                        <div class="clearfix"></div>
                    </div>

                    <div class="clearfix"></div>

                </div>

            </div>

            <div v-if="showAddTag" @click.self="showAddTag = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/4 lg:w-1/4 bg-white rounded-lg mx-6">

                    <div class="rg-modal-header">
                    Add Tag

                    <a href="javascript: void(0);" class="rg-modal-close-btn" @click="showAddTag = false"><i class="mdi mdi-close"></i></a>
                    </div>

                    <div class="p-6" style="position: relative;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div class="flex flex-row flex-wrap">
                        <div :class="'w-full mb-3'">
                            <p class="mb-1 text-xs mb-2"><strong>New Tag</strong></p>
                            <input v-model="new_tag" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                                placeholder="Enter tag here"
                            />

                            <p class="text-sm text-gray-600 pt-2">
                                Enter a custom tag
                            </p>
                        </div>
                        <div :class="'w-full mb-3'">
                            <p class="mb-1 text-xs mb-2"><strong>Tag Color</strong></p>
                            <input v-model="new_tag_color" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; width: 100px;"
                                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                                type="color"
                                placeholder="#000000"
                            />

                            <p class="text-sm text-gray-600 pt-2">
                                Specify a custom color for this tag
                            </p>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingTag}" @click="saveTag">
                        SAVE
                    </button>

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showAddTag = false">
                        CLOSE
                    </button>

                    <div class="clearfix"></div>

                    </div>

                </div>
                </div>

            <div v-if="showAddStatus" @click.self="showAddStatus = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/4 lg:w-1/4 bg-white rounded-lg mx-6">

                    <div class="rg-modal-header">
                    Add Custom Status

                    <a href="javascript: void(0);" class="rg-modal-close-btn" @click="showAddStatus = false"><i class="mdi mdi-close"></i></a>
                    </div>

                    <div class="p-6" style="position: relative;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div class="flex flex-row flex-wrap">
                        <div :class="'w-full mb-3'">
                            <p class="mb-1 text-xs mb-2"><strong>New Status</strong></p>
                            <input v-model="new_status" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                                placeholder="Enter status here"
                            />

                            <p class="text-sm text-gray-600 pt-2">
                                Enter a custom status
                            </p>
                        </div>
                        <div :class="'w-full mb-3'">
                            <p class="mb-1 text-xs mb-2"><strong>Status Color</strong></p>
                            <input v-model="new_status_color" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; width: 100px;"
                                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                                type="color"
                                placeholder="#000000"
                            />

                            <p class="text-sm text-gray-600 pt-2">
                                Specify a custom color for this status
                            </p>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingStatus}" @click="saveStatus">
                        SAVE
                    </button>

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showAddStatus = false">
                        CLOSE
                    </button>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div v-if="showCallRailRecording" @click.self="showCallRailRecording = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="rg-modal-header">
                    Show Recording

                    <a href="javascript: void(0);" class="rg-modal-close-btn" @click="showCallRailRecording = false"><i class="mdi mdi-close"></i></a>
                    </div>

                    <div class="p-6" style="position: relative; height: calc(100% - 110px); overflow: auto;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div>
                        <div v-if="loading_callrail_recording" :class="'w-full mb-3'">
                            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                        </div>
                        <div class="flex flex-row flex-wrap" v-else>
                            <div class="w-full mb-4">
                                <!-- <iframe :src="callrail_recording_data.recording_url" style="width: 100%; height: 500px; border: 0px;"></iframe> -->
                                <div id="cr-audio-el-here"></div>
                            </div>
                            <div class="w-full">
                                <hr />
                                <div style="max-height: 500px; overflow: auto;">
                                    <div v-if="!callrail_recording_data.transcription" class="text-sm" style="text-align: center;">
                                        <br />
                                        No transcription available.
                                    </div>
                                    <div v-else>
                                        <b-list-group>
                                            <b-list-group-item

                                                v-for="(item, index) in callrail_recording_data.transcription" :key="index"
                                        
                                                    class="d-flex align-items-center mb-4 pb-4"
                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                            >
                                                <b-avatar v-if="item.speaker == 'agent'"
                                                        text="S1"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <b-avatar v-if="item.speaker == 'caller'"
                                                        text="S2"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <div>
                                                    <span v-if="item.speaker == 'agent' && lsa_item.sources.indexOf('bland') != -1" class="mr-auto primary-color text-bold">AI AGENT</span>
                                                    <span v-if="item.speaker == 'agent' && lsa_item.sources.indexOf('bland') == -1" class="mr-auto primary-color text-bold">Advertiser</span>
                                                    <span v-else class="mr-auto warning-color text-bold">Caller</span>

                                                    <span class="mr-auto"> . {{ displaySpeakerTimestamp(item.start*1000) }} . </span>
                                                    <!-- <span v-if="item.sentiment == 'Neutral'" class="mr-auto warning-color text-bold">Neutral</span>
                                                    <span v-if="item.sentiment == 'Positive'" class="mr-auto success-color text-bold">Positive</span>
                                                    <span v-if="item.sentiment == 'Negative'" class="mr-auto danger-color text-bold">Negative</span> -->
                                                    <div class="text-sm">{{ item.phrase }}</div>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showCallRailRecording = false">
                        CLOSE
                    </button>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div v-if="showBlandRecording" @click.self="showBlandRecording = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-2/3 lg:w-2/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="p-6" style="position: relative; height: calc(100% - 20px); overflow: auto;">

                        <div class="float-right -mb-4" style="position: relative;">
                            <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->

                            <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="translateTexts('bland', 'spanish')">
                                <i class="mdi mdi-text-box-edit-outline"></i> TRANSLATE TO ENGLISH
                            </button>
                        </div>

                        <div class="float-right -mb-4" style="position: relative;">
                            <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="ai_messages_lead.show_ai_feedback = !ai_messages_lead.show_ai_feedback || true;">
                                <i class="mdi mdi-robot-outline"></i>
                                &nbsp;
                                <span v-if="ai_messages_lead.ai_feedback_urgent">🚨</span>
                                &nbsp;
                                <strong v-if="ai_messages_lead.ai_feedback">AI FEEDBACK</strong><span v-else="">AI FEEDBACK</span>
                            </button>

                            <div v-show="ai_messages_lead.show_ai_feedback" style="position: absolute; background: #FFFFFF; padding: 10px; border: solid 1px #CCCCCC; width: 250px; z-index: 1; margin-top: 40px;">
                                <textarea v-model="ai_messages_lead.ai_feedback" style="padding: 10px; width: 100%; height: 200px; border: solid 1px #CCCCCC; border-radius: 5px;"></textarea>

                                <br />

                                <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="ai_messages_lead.ai_feedback_urgent" label="Urgent"></v-switch>

                                <br />

                                <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 w-full mb-2" :class="{'spinner': savingAiFeedback}" @click="saveAiFeedback(ai_messages_lead)">
                                    SAVE
                                </button>

                                <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 w-full w-full mb-2" :class="{'spinner': savingAiFeedback}" @click="ai_messages_lead.show_ai_feedback = false;">
                                    CLOSE
                                </button>
                            </div>
                        </div>

                    <div style="clear: both; padding-top: 10px;"></div>

                    <div>
                        <div v-if="loading_bland_recording" :class="'w-full mb-3'">
                            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                        </div>
                        <div class="flex flex-row flex-wrap" v-else>
                            <div class="w-full mb-4">
                                <!-- <iframe :src="bland_recording_data.recording_url" style="width: 100%; height: 500px; border: 0px;"></iframe> -->
                                <div id="bl-audio-el-here"></div>
                            </div>
                            <div class="w-full">
                                <hr />
                                <div id="ai-dialog-messages-list"  style="max-height: 500px; overflow: auto;">

                                    <div v-if="!bland_recording_data.transcription" class="text-sm" style="text-align: center;">
                                        <br />
                                        No transcription available.
                                    </div>
                                    <div v-else>
                                        <div v-if="bland_recording_data.lead_type == 'PHONE_CALL'">
                                            <div class="flex flex-row flex-wrap w-full">
                                                <div :class="'w-full lg:w-1/2'">
                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Transcription</div>

                                                    <br />
                                                    <div>
                                                        <b-list-group>
                                                            <b-list-group-item
                                                                v-for="(item, index) in bland_recording_data.transcription" :key="index"
                                                        
                                                                    class="d-flex align-items-center mb-4 pb-4"
                                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                                                    v-if="index !== 'messages'"
                                                            >
                                                                <b-avatar v-if="item.speaker == 'A'"
                                                                        text="S1"
                                                                        class="mr-3 call-info-avatar"
                                                                ></b-avatar>
                                                                <b-avatar v-if="item.speaker == 'B'"
                                                                        text="S2"
                                                                        class="mr-3 call-info-avatar"
                                                                ></b-avatar>
                                                                <div>
                                                                    <span v-if="item.speaker == 'A'" class="mr-auto primary-color text-bold">AI</span>
                                                                    <span v-else class="mr-auto warning-color text-bold">Caller</span>

                                                                    <span class="mr-auto"> . {{ displaySpeakerTimestamp(item.start, bland_recording_data.transcription[0].start) }} . </span>
                                                                    <!-- <span v-if="item.sentiment == 'Neutral'" class="mr-auto warning-color text-bold">Neutral</span>
                                                                    <span v-if="item.sentiment == 'Positive'" class="mr-auto success-color text-bold">Positive</span>
                                                                    <span v-if="item.sentiment == 'Negative'" class="mr-auto danger-color text-bold">Negative</span> -->
                                                                    <div class="text-sm">{{ item.text }}</div>
                                                                </div>
                                                            </b-list-group-item>
                                                        </b-list-group>
                                                    </div>
                                                </div>
                                                <div :class="'w-full lg:w-1/2 pl-3'">
                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Summary</div>

                                                    <div style="font-size: 12px;">{{ bland_recording_data.summary || "No summary found." }}</div>

                                                    <!-- <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Sentiment</div>

                                                    <div style="font-size: 12px;">{{ bland_recording_data.sentiment || "UNKNOWN" }}</div>

                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Topics Discussed</div>

                                                    <div style="font-size: 12px;">{{ bland_recording_data.topics_discussed || "No topics discussed." }}</div>

                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Issues Raised</div>

                                                    <div style="font-size: 12px;">{{ bland_recording_data.issues_raised || "No issues raised." }}</div> -->

                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Customer Information</div>

                                                    <div style="font-size: 12px;">
                                                        <strong>Customer's name:</strong> {{ bland_recording_data.customer_name || "-" }}
                                                        <br />
                                                        <strong>Customer's email:</strong> {{ bland_recording_data.customer_email || "-" }}
                                                        <br />
                                                        <strong>Customer's phone:</strong> {{ bland_recording_data.ai_provided_phone_number || "-" }}
                                                        <br />
                                                        <strong>Service needed:</strong> {{ bland_recording_data.job_type || "-" }}
                                                        <br /><br />
                                                        <strong>Call ended by:</strong> {{ bland_recording_data.call_ended_by || "-" }}
                                                    </div>

                                                    <!--<div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Analysis</div>

                                                    <div v-if="bland_recording_data.analysis" style="font-size: 12px;">
                                                        <div v-for="(item, index) in bland_recording_data.analysis" :key="'variable-' + index">
                                                            <strong>{{ index }}: </strong> {{ item }} <br />
                                                        </div>
                                                    </div>
                                                    <div v-else style="font-size: 12px;">No analysis detected.</div>-->

                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Variables</div>

                                                    <div v-if="bland_recording_data.variables" style="font-size: 12px;">
                                                        <div v-for="(item, index) in bland_recording_data.variables" :key="'variable-' + index">
                                                            <strong>{{ index }}: </strong> {{ item }} <br />
                                                        </div>
                                                    </div>
                                                    <div v-else style="font-size: 12px;">No variables.</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <b-list-group>
                                                <b-list-group-item
                                                    v-for="(item, index) in bland_recording_data.transcription.messages" :key="index"
                                            
                                                        class="d-flex align-items-center mb-4 pb-4"
                                                        style="border: none; border-bottom: solid 1px #ededed;"
                                                >

                                                    <b-avatar v-if="(!item.is_bland && item.sender != 'bot') || item.is_person"
                                                            text="S1"
                                                            class="mr-3 call-info-avatar"
                                                    ></b-avatar>
                                                    <b-avatar v-if="(item.is_bland || item.sender == 'bot') && !item.is_person"
                                                            text="S2"
                                                            class="mr-3 call-info-avatar"
                                                    ></b-avatar>
                                                    <div>
                                                        <span v-if="item.custom_name">
                                                            <span class="mr-auto primary-color text-bold">{{ item.custom_name }}</span>
                                                        </span>
                                                        <span v-else>
                                                            <span v-if="item.is_person" class="mr-auto primary-color text-bold">{{ me.first_name }} {{ me.last_name }}</span>
                                                            <span v-if="(item.is_bland || item.sender == 'bot') && !item.is_person" class="mr-auto primary-color text-bold">AI Agent</span>
                                                            <span v-if="!item.is_bland && item.sender != 'bot' && !item.is_person" class="mr-auto warning-color text-bold">Customer</span>
                                                        </span>

                                                        <span class="mr-auto text-xs text-gray-600"> . {{ displayTimestamp(item.timestamp) }} . </span>
                                                        <!-- <span v-if="item.sentiment == 'Neutral'" class="mr-auto warning-color text-bold">Neutral</span>
                                                        <span v-if="item.sentiment == 'Positive'" class="mr-auto success-color text-bold">Positive</span>
                                                        <span v-if="item.sentiment == 'Negative'" class="mr-auto danger-color text-bold">Negative</span> -->
                                                        <div class="text-sm">
                                                            {{ item.message }}

                                                            <ReinforcementLearning v-if="item.is_bland && !item.is_person" :message="item.message" />
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                            </b-list-group>
                                        </div>
                                    </div>
                                </div>

                                <div v-show="bland_recording_data.transcription.messages" class="mt-4 -mb-12">

                                    <div v-if="$store.state.auth.admin || $store.state.auth.owner" style="padding-bottom: 5px; margin-top: -20px;">

                                        <v-select
                                            outlined
                                            dense
                                            hide-details
                                            label="Respond as"
                                            class="white header-inputs mb-2"
                                            :items="[profile.first_name, 'AI Agent']"
                                            v-model="respond_as"
                                        ></v-select>
                                    </div>

                                    <v-text-field
                                        clearable
                                        outlined
                                        dense
                                        hide-details
                                        label="Reply"
                                        v-model="new_ai_message"

                                        class="white border border-white"
                                    ></v-text-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showBlandRecording = false">
                        CLOSE
                    </button>

                    <button
                            class="rg-dialog-button-save custom-button rounded bg-gray-500 hover:bg-gray-600 text-white focus:outline-none py-2 px-4 float-left"
                            :class="{ spinner: sendingAiMessage }"
                            @click="sendAiReply()"
                            :disabled="!new_ai_message"
                    >
                        SEND
                    </button>

                    <div style="float: right; padding-right: 30px; padding-top: 6px;">
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="ai_messages_lead.ai_enabled" label="AI Response Enabled" @change="switchAiResponseEnabled(ai_messages_lead);"></v-switch>
                    </div>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div v-if="showLsaRecordings" @click.self="showLsaRecordings = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="p-6" style="position: relative; height: calc(100% - 20px); overflow: auto;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div>
                        <div v-if="loading_lsa_recordings" :class="'w-full mb-3'">
                            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                        </div>
                        <div class="flex flex-row flex-wrap" v-else>
                            <div class="w-full mb-4">
                                <!-- <iframe :src="bland_recording_data.recording_url" style="width: 100%; height: 500px; border: 0px;"></iframe> -->
                                <div id="lsa-audio-el-here"></div>

                                <div class="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4 mb-4" role="alert">
                                    <div>According to Google's policy, you must be logged in to your LSA account in this browser. Please make sure you are logged in on <a href="https://ads.google.com/localservices" target="lsa-account-login">https://ads.google.com/localservices</a> in order to play the recordings in your software.</div>
                                </div>

                                <div id="ai-dialog-messages-list"  style="max-height: 500px; overflow: auto;">

                                    <div v-if="!lsa_recording_data.transcription" class="text-sm" style="text-align: center;">
                                        <br />
                                        No transcription available.
                                    </div>
                                    <div v-else>
                                        <div>
                                            <div class="flex flex-row flex-wrap w-full">
                                                <div :class="'w-full'">
                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Transcription</div>

                                                    <br />
                                                    <div>
                                                        <b-list-group>
                                                            <b-list-group-item
                                                                v-for="(item, index) in lsa_recording_data.transcription" :key="index"
                                                        
                                                                    class="d-flex align-items-center mb-4 pb-4"
                                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                                                    v-if="index !== 'messages'"
                                                            >
                                                                <b-avatar v-if="(item.speaker == 'A' || item.speaker == 'C')"
                                                                        text="S1"
                                                                        class="mr-3 call-info-avatar"
                                                                ></b-avatar>
                                                                <b-avatar v-if="item.speaker == 'B'"
                                                                        text="S2"
                                                                        class="mr-3 call-info-avatar"
                                                                ></b-avatar>
                                                                <div>
                                                                    <span v-if="(item.speaker == 'A' || item.speaker == 'C') && lsa_item.sources.indexOf('bland') !== -1" class="mr-auto primary-color text-bold">AI</span>
                                                                    <span v-if="item.speaker == 'A' && lsa_item.sources.indexOf('bland') === -1" class="mr-auto primary-color text-bold">Advertiser</span>
                                                                    <span v-else class="mr-auto warning-color text-bold">Caller</span>

                                                                    <span class="mr-auto"> . {{ displaySpeakerTimestamp(item.start, lsa_recording_data.transcription[0].start) }} . </span>
                                                                    <!-- <span v-if="item.sentiment == 'Neutral'" class="mr-auto warning-color text-bold">Neutral</span>
                                                                    <span v-if="item.sentiment == 'Positive'" class="mr-auto success-color text-bold">Positive</span>
                                                                    <span v-if="item.sentiment == 'Negative'" class="mr-auto danger-color text-bold">Negative</span> -->
                                                                    <div class="text-sm">{{ item.text }}</div>
                                                                </div>
                                                            </b-list-group-item>
                                                        </b-list-group>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showLsaRecordings = false">
                        CLOSE
                    </button>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div v-if="showLsaMessages" @click.self="showLsaMessages = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="p-6" style="position: relative; height: calc(100% - 65px); overflow: auto;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div>
                        <div v-if="loading_lsa_messages" :class="'w-full mb-3'">
                            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                        </div>
                        <div class="flex flex-row flex-wrap" v-else>
                            <div class="w-full">
                                <div id="lsa-dialog-messages-list" style="max-height: 450px; overflow: auto;">
                                    <div v-if="lsa_messages_displayed.length == 0" class="text-sm" style="text-align: center;">
                                        <br />
                                        No transcription available.
                                    </div>
                                    <div v-else>
                                        <b-list-group>
                                            <b-list-group-item

                                                v-for="(item, index) in lsa_messages_displayed" :key="index"
                                        
                                                    class="d-flex align-items-center mb-4 pb-4"
                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                            >
                                                <b-avatar v-if="item.participant_type == 2"
                                                        text="S1"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <b-avatar v-if="item.participant_type == 3"
                                                        text="S2"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <div>
                                                    <span v-if="item.participant_type == 2" class="mr-auto primary-color text-bold">Advertiser</span>
                                                    <span v-else class="mr-auto warning-color text-bold">Customer</span>

                                                    <span class="mr-auto text-xs text-gray-600"> . {{ displayTimestamp(item.event_time) }} . </span>
                                                    <div class="text-sm" v-html="item.text"></div>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </div>
                                </div>

                                <div>
                                    <v-text-field
                                        clearable
                                        outlined
                                        dense
                                        hide-details
                                        label="Reply"
                                        v-model="new_lsa_message"

                                        class="white border border-white"
                                    ></v-text-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showLsaMessages = false">
                        CLOSE
                    </button>

                    <button
                            class="rg-dialog-button-save custom-button rounded bg-gray-500 hover:bg-gray-600 text-white focus:outline-none py-2 px-4"
                            :class="{ spinner: sendingLsaMessage }"
                            @click="sendLsaReply()"
                            :disabled="!new_lsa_message"
                    >
                        SEND
                    </button>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div v-if="show_notes_dialog" @click.self="show_notes_dialog = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="rg-modal-header">
                        Notes

                        <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_notes_dialog = false"><i class="mdi mdi-close"></i></a>
                    </div>

                    <div class="p-6" style="position: relative; overflow: auto;">

                        <div style="clear: both;"></div>

                        <div>

                            <div style="font-size: 12px; padding-bottom: 20px;">
                                <div v-if="notes_lead.notes.length == 0">
                                    No notes found.
                                </div>

                                <div v-else>
                                    <div v-for="(note, note_index) in notes_lead.notes" style="clear: both; padding-bottom: 10px;">
                                        <div style="float: left; width: calc(100% - 220px);">
                                            {{ note.note }}
                                        </div>

                                        <div style="float: right; width: 200px; text-align: right;">
                                            [{{ formatDate(note.timestamp) }}]

                                            &nbsp;&nbsp;

                                            <a href="javascript: void(0);"><i class="mdi mdi-delete-outline" style="color: red;" @click="deleteNote(note_index)"></i></a>
                                        </div>

                                        <div style='clear: both;'></div>
                                    </div>

                                    <div style='clear: both;'></div>
                                </div>
                            </div>

                            <v-text-field
                                clearable
                                outlined
                                dense
                                hide-details
                                label="Add Note"
                                v-model="new_note"

                                class="white border border-white"
                            ></v-text-field>
                            
                        </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                        <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingNote}" @click="saveNote">
                            ADD
                        </button>

                        <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_notes_dialog = false">
                            CLOSE
                        </button>

                    <div class="clearfix"></div>

                    </div>
                </div>
            </div>

            <div v-if="showAddStatus" @click.self="showAddStatus = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/4 lg:w-1/4 bg-white rounded-lg mx-6">

                    <div class="rg-modal-header">
                    Add Custom Status

                    <a href="javascript: void(0);" class="rg-modal-close-btn" @click="showAddStatus = false"><i class="mdi mdi-close"></i></a>
                    </div>

                    <div class="p-6" style="position: relative;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div class="flex flex-row flex-wrap">
                        <div :class="'w-full mb-3'">
                            <p class="mb-1 text-xs mb-2"><strong>New Status</strong></p>
                            <input v-model="new_status" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                                placeholder="Enter status here"
                            />

                            <p class="text-sm text-gray-600 pt-2">
                                Enter a custom status
                            </p>
                        </div>
                        <div :class="'w-full mb-3'">
                            <p class="mb-1 text-xs mb-2"><strong>Status Color</strong></p>
                            <input v-model="new_status_color" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; width: 100px;"
                                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                                type="color"
                                placeholder="#000000"
                            />

                            <p class="text-sm text-gray-600 pt-2">
                                Specify a custom color for this status
                            </p>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingStatus}" @click="saveStatus">
                        SAVE
                    </button>

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showAddStatus = false">
                        CLOSE
                    </button>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div v-if="shouldShowChatConversation" @click.self="shouldShowChatConversation = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="p-6" style="position: relative; height: calc(100% - 20px); overflow: auto;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div>
                        <div v-if="loading_chat_conversation" :class="'w-full mb-3'">
                            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                        </div>
                        <div class="flex flex-row flex-wrap" v-else>
                            <div class="w-full">
                                <div id="chat-dialog-messages-list" style="max-height: 500px; overflow: auto;">
                                    <div>
                                        <b-list-group>
                                            <b-list-group-item

                                                v-for="(item, index) in bland_transcription.messages" :key="index"
                                        
                                                    class="d-flex align-items-center mb-4 pb-4"
                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                            >
                                                <b-avatar v-if="item.role == 'assistant' || !item.role"
                                                        text="S1"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <b-avatar v-if="item.role == 'user'"
                                                        text="S2"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <div>
                                                    <span v-if="!item.role" class="mr-auto primary-color text-bold">{{ me.first_name }} {{ me.last_name }}</span>
                                                    <span v-else>
                                                        <span v-if="item.role == 'assistant'" class="mr-auto primary-color text-bold">AI Agent</span>
                                                        <span v-else class="mr-auto warning-color text-bold">Customer</span>
                                                    </span>

                                                    <span class="mr-auto text-xs text-gray-600"> . {{ displayTimestamp(item.timestamp) }} . </span>
                                                    <div class="text-sm">{{ item.content }} <ReinforcementLearning v-if="item.role == 'assistant'" :message="item.content" /></div>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </div>
                                </div>

                                <div class="mt-4 -mb-12">
                                    <v-text-field
                                        clearable
                                        outlined
                                        dense
                                        hide-details
                                        label="Reply"
                                        v-model="new_ai_message"

                                        class="white border border-white"
                                    ></v-text-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                        <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="shouldShowChatConversation = false">
                            CLOSE
                        </button>

                        <button
                                class="rg-dialog-button-save custom-button rounded bg-gray-500 hover:bg-gray-600 text-white focus:outline-none py-2 px-4 float-left"
                                :class="{ spinner: sendingAiMessage }"
                                @click="sendAiReply()"
                                :disabled="!new_ai_message"
                        >
                            SEND
                        </button>

                        <div style="float: right; padding-right: 30px; padding-top: 6px;">
                            <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="ai_messages_lead.ai_enabled" label="AI Response Enabled" @change="switchAiResponseEnabled(ai_messages_lead);"></v-switch>
                        </div>

                        <div class="clearfix"></div>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div class="rg-top-filter pt-1 float-right mr-2">
                <v-text-field
                    :value="formatDate(date_filter[0], 'MMM DD, YYYY') + '   -   ' + ((date_filter[1]) ? formatDate(date_filter[1], 'MMM DD, YYYY') : '')"
                    append-icon="mdi-calendar-blank-outline"
                    readonly
                    outlined
                    dense
                    style="width: 230px; background: #4EC5A1; color: #FFFFFF !important; border: 0px !important;"
                    hide-details
                    placholder="Choose Date"
                    @click="show_picker = !show_picker"
                ></v-text-field>
                
                <div v-if="show_picker" style="position: absolute; width: 490px; z-index: 999; margin-left: -260px; background: #FFFFFF; padding: 10px; margin-top: 5px; border-radius: 10px; box-shadow: 0px 0px 30px 0px #E2E2E2;">
                    <div style="float: left; border-right: solid 1px #d5d5d5;">
                    <div class="mb-2"><strong class="text-sm">Filter by Date</strong></div>

                    <v-date-picker
                    v-model="date_filter"
                    range
                    no-title
                    scrollable
                    @input="menu = false"
                    style="border: 0px;"
                    >
                    <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="#44468F"
                            @click="show_picker = false"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="#44468F"
                            @click="filterDate();"
                        >
                            UPDATE
                        </v-btn>
                    </v-date-picker>
                    </div>

                    <div style="float: left; margin-left: 20px; padding-left: 20px; padding-top: 20px;">
                    <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('This Week')" :style="((selected_date_text == 'This Week') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">This Week</a></div>
                    <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last Week')" :style="((selected_date_text == 'Last Week') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last Week</a></div>
                    <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('This Month')" :style="((selected_date_text == 'This Month') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">This Month</a></div>
                    <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last Month')" :style="((selected_date_text == 'Last Month') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last Month</a></div>
                    <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 60 days')" :style="((selected_date_text == 'Last 60 days') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 60 days</a></div>
                    <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 90 days')" :style="((selected_date_text == 'Last 90 days') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 90 days</a></div>
                    <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('This Year')" :style="((selected_date_text == 'This Year') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">This Year</a></div>
                    <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last Year')" :style="((selected_date_text == 'Last Year') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last Year</a></div>
                    <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('All Time')" :style="((selected_date_text == 'All Time') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">All Time</a></div>
                    </div>

                    <div style="clear: both;"></div>
                </div>
            </div>

            <h1 class="text-lg font-semibold mb-3"><span v-if="isSeoTab()">SEO Leads</span><span v-else>Leads</span>
                <v-chip
                        class="ma-2"
                        color="#44468F"
                        outlined
                        small
                >
                    {{ messages.length }}
                </v-chip>
            </h1>
            <hr class="border-b border-gray-100 mb-3">

            <template>

                <div class="border-1 border-purple bg-purple text-white text-xs text-bold px-4 rounded cursor-pointer float-right ml-2 mt-3" style="padding-bottom: 11px; padding-top: 11px;"
                    @click="getMessages();"
                >
                    Filter
                </div>

                <div class="border-1 border-gray bg-white text-gray text-xs text-bold px-4 rounded cursor-pointer float-right ml-2 mt-3" style="padding-bottom: 3px; padding-top: 3px;"
                    @click="showExtraFilters = !showExtraFilters"
                >
                    <i v-show="showExtraFilters == false" class="mdi mdi-filter-plus-outline" style="font-size: 22px;"></i>
                    <i v-show="showExtraFilters == true" class="mdi mdi-filter-minus-outline" style="font-size: 22px;"></i>
                </div>

                <div class="-mx-3">
                    <v-row class="my-3 rg-top-filter-black-text">
                        <v-col cols="12" md="3" sm="3" xs="6">
                            <v-text-field
                                    clearable
                                    outlined
                                    dense
                                    hide-details
                                    prepend-inner-icon="mdi-magnify"
                                    label="Search"
                                    v-model="search"

                                    class="white border border-white"
                            ></v-text-field>
                        </v-col>
                        <template>
                            <v-col v-show="showExtraFilters" cols="12" md="3" sm="3" xs="6">
                                <v-select
                                        outlined
                                        dense
                                        hide-details
                                        label="Tags"
                                        class="white header-inputs"
                                        :item-text="item => item.text"
                                        :item-value="item => item.index"
                                        :items="tags_items"
                                        v-model="tag"
                                        clearable
                                ></v-select>
                            </v-col>
                            <v-spacer></v-spacer>
                             <v-col v-show="showExtraFilters" cols="12" md="3" sm="3" xs="6">
                                <v-select
                                        outlined
                                        dense
                                        hide-details
                                        label="Archived"
                                        class="white header-inputs"
                                        :items="['Show All', 'Show Unarchived', 'Show Archived']"
                                        v-model="archived_filter"
                                        clearable
                                ></v-select>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col v-show="showExtraFilters" cols="12" md="3" sm="3" xs="6">
                                <div>
                                    <v-select
                                            clearable
                                            outlined
                                            dense
                                            hide-details
                                            label="Status"
                                            :item-text="item => item.text"
                                            :item-value="item => item.index"
                                            class="white header-inputs"
                                            :items="qualify_status_items"
                                            v-model="qualify_status"
                                            clearable
                                    ></v-select>
                                </div>
                            </v-col>
                        </template>
                    </v-row>
                </div>

                <div v-show="showExtraFilters">
                    <v-row class="mb-3 rg-top-filter-black-text">
                        <v-col cols="12" md="4" sm="4" xs="6">
                            <v-select
                                outlined
                                dense
                                hide-details
                                label="Channel"
                                class="white header-inputs"
                                :items="['AI', 'LSA', 'CallRail']"
                                v-model="channel_filter"
                                clearable
                                @change="getMessages(true)"
                            ></v-select>
                        </v-col>
                        <v-spacer></v-spacer>
                         <v-col cols="12" md="4" sm="4" xs="6">
                            <v-select
                                outlined
                                dense
                                hide-details
                                label="Lead Type"
                                class="white header-inputs"
                                :items="['Calls', 'Messages', 'Web Chat']"
                                v-model="lead_type_filter"
                                clearable
                                @change="getMessages(true)"
                            ></v-select>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="12" md="4" sm="4" xs="6">
                            <v-select
                                outlined
                                dense
                                hide-details
                                label="Charge Status"
                                class="white header-inputs"
                                :items="['Charged', 'Not Charged']"
                                v-model="charge_status_filter"
                                clearable
                                @change="getMessages(true)"
                            ></v-select>
                        </v-col>
                    </v-row>
                </div>
            </template>
            <template>
                <div class="dashboard-box">
                    <v-card class="pa-2" tile>
                        <v-skeleton-loader v-if="loading" type="article, article, article"></v-skeleton-loader>

                        <div v-else class="p-3">
                            <div v-if="messages.length == 0">
                                <br clear="all" /><br/><br/><br/>
                                <div class="dashboard-box-iconsquare">
                                    <div class="dashboard-box-icon-background"></div>
                                    <div class="dashboard-box-icon">
                                        <i class="mdi mdi-phone"></i>
                                    </div>
                                </div>
                                <div style="text-align: center;">
                                    <div class="pt-2 pb-2">
                                        <strong>No Leads</strong>
                                    </div>

                                    <div class="text-sm mb-4 text-gray-600">
                                        No leads found for the given period. Refine your search or wait until new leads come in.
                                    </div>
                                    <br/>
                                </div>
                                <br/><br/><br/><br/><br/>
                            </div>

                            <div v-else style="clear: both; padding-top: 0px;">

                                <div style="float: left;" v-show="!isAccelerate() && selected.length > 0">
                                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="markAsGoodCallsForSurvey();">
                                        Train Agent with selected calls
                                    </button>
                                </div>

                                <div v-show="showResetButton" style="float: left;">
                                    <a href="javascript: void(0);" style="font-size: 12px;" @click="filterBy('')">&lt; Back</a>
                                </div>

                                <div style="float: right; font-size: 12px; line-height: 20px; margin-top: -5px; text-align: right;">
                                    <div class="stats-btn" style="padding: 6px; border: solid 1px #CCCCCC; border-radius: 5px; background: #FFFFFF; padding-left: 10px; padding-right: 10px;">
                                        Stats

                                        <div  class="stats-div" style="padding: 6px;border: 1px solid rgb(204, 204, 204);border-radius: 5px;background: rgb(255, 255, 255);position: absolute;width: 200px;margin-left: -158px;z-index: 3;">
                                            <div style="">Total: <strong>{{ messages.length }}</strong></div>
                                            <div style="padding-top: 15px;">AI: <strong>{{ ai_leads_count }}</strong> (<i class="mdi mdi-message-outline"></i> {{ ai_leads_count_msg }} | <i class="mdi mdi-phone"></i> {{ ai_leads_count_voice }} )</div>
                                            <div style="">LSA: <strong>{{ lsa_leads_count }}</strong></div>
                                            <div style="">CallRail: <strong>{{ callrail_leads_count }}</strong></div>

                                            <div style="padding-top: 15px;">Converted: <strong>{{ converted_leads_count }}</strong> ({{ ((messages.length == 0) ? '0' : (parseInt((converted_leads_count/messages.length) * 100))) }}%)</div>
                                            <div style="">Booked: <strong>{{ booked_leads_count }}</strong> ({{ ((messages.length == 0) ? '0' : (parseInt((booked_leads_count/messages.length) * 100))) }}%)</div>
                                            <div style="padding-top: 15px;">Converted AI: <strong>{{ converted_ai_leads_count }}</strong> ({{ ((converted_leads_count == 0) ? '0' : (parseInt((converted_ai_leads_count/converted_leads_count) * 100))) }}%)</div>
                                            <div style="">Converted Human: <strong>{{ converted_human_leads_count }}</strong> ({{ ((converted_leads_count == 0) ? '0' : (parseInt((converted_human_leads_count/converted_leads_count) * 100))) }}%)</div>
                                            <div style="">Booked AI: <strong>{{ booked_ai_leads_count }}</strong> ({{ ((booked_leads_count == 0) ? '0' : (parseInt((booked_ai_leads_count/booked_leads_count) * 100))) }}%)</div>
                                            <div style="">Booked Human: <strong>{{ booked_human_leads_count }}</strong> ({{ ((booked_leads_count == 0) ? '0' : (parseInt((booked_human_leads_count/booked_leads_count) * 100))) }}%)</div>
                                        </div>
                                    </div>
                                </div>

                                <div style="float: right; font-size: 12px; line-height: 20px; margin-top: -5px; text-align: right; margin-right: 6px;">
                                    <div class="stats-btn" style="padding: 6px; border: solid 1px #CCCCCC; border-radius: 5px; background: #FFFFFF; padding-left: 10px; padding-right: 10px; cursor: pointer;" @click="downloadCsv">
                                        <i class="mdi mdi-file-delimited-outline"></i> Download CSV
                                    </div>
                                </div>

                                <div v-show="!isAccelerate()" style="float: right; font-size: 12px; line-height: 20px; margin-top: -5px; text-align: right; margin-right: 6px;">
                                    <div class="stats-btn" style="padding: 6px; border: solid 1px #CCCCCC; border-radius: 5px; background: #FFFFFF; padding-left: 10px; padding-right: 10px; cursor: pointer;" @click="getMonthlyReport">
                                        <i class="mdi mdi-file-outline"></i> Get Monthly Report
                                    </div>
                                </div>

                                <div v-show="!isAccelerate()" style="float: right; font-size: 12px; line-height: 20px; margin-top: -5px; text-align: right; margin-right: 6px;">
                                    <div class="stats-btn" style="padding: 6px; border: solid 1px #CCCCCC; border-radius: 5px; background: #FFFFFF; padding-left: 10px; padding-right: 10px; cursor: pointer;" @click="sendMonthlyReport">
                                        <i class="mdi mdi-email"></i> Send Monthly Report
                                    </div>
                                </div>

                                <div style="clear: both; padding-bottom: 10px;"></div>

                                <div v-if="me && $vuetify.breakpoint.mobile">

                                    <div v-for="(item, index) in messages" style="padding-bottom: 5px; margin-bottom: 5px; border-bottom: solid 1px #CCCCCC;">
                                        <div v-show="item.lead_id" style="float: right;">
                                            <strong>Lead ID:</strong> {{ item.lead_id }}
                                        </div>

                                        <span :style="((item.archived == 1) ? 'text-decoration: line-through;' : '')"><a href="javascript: void(0);" @click="filterBy(item.customer_phone_number)">{{ item.customer_phone_number }}</a></span>

                                        <div style="clear: both;"></div>

                                        <div class="flex items-center gap-2">
                                            <div class="flex items-center gap-2">
                                            <v-tooltip v-for="p in normalizedProviders(item)" :key="p.key" top color="primary">
                                            <template #activator="{ on, attrs }">
                                            <img
                                            v-bind="attrs"
                                            v-on="on"
                                            :src="p.src"
                                            :alt="p.title"
                                            class="rg-channel-icon"
                                            @click="p.onClick && p.onClick(item)"
                                            :style="((me && me.is_medical) ? 'cursor: initial;' : 'cursor: pointer;') + ((p.title == 'AI' || p.title == 'Web Chat') ? 'width: 52px; height: 52px; margin-left: -10px;' : '')"
                                            />
                                            </template>
                                            <span>{{ p.title }}</span>
                                            </v-tooltip>
                                            </div>


                                            <!-- Modality chip (Call / Message / Booking) -->
                                            <span class="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-slate-300 ml-1" style="background-color: #CCCCCC;">
                                            <i v-if="item.lead_type == 'PHONE_CALL'" class="mdi mdi-phone"></i>
                                            <i v-else-if="item.lead_type == 'MESSAGE'" class="mdi mdi-message-text-outline"></i>
                                            <i v-else-if="item.sources == 'web'" class="mdi mdi-chat"></i>
                                            <i v-else class="mdi mdi-information-outline"></i>
                                            <span v-if="item.lead_type == 'PHONE_CALL'">Call</span>
                                            <span v-else-if="item.sources == 'web'">CHAT</span>
                                            <span v-else-if="item.lead_type == 'MESSAGE'">Message</span>
                                            <span v-else-if="item.lead_type == 'BOOKING'">Booking</span>
                                            <span v-else>-</span>
                                            </span>

                                            <a href="javascript: void(0);" @click="leadDetailsMobile = item; showFullLeadDetailsMobile = true;">View Details</a>
                                        </div>
                                    </div>
                                </div>

                                <v-data-table
                                v-if="me && !$vuetify.breakpoint.mobile"
                                :headers="computedHeaders"
                                :items="messages"
                                :items-per-page="20"
                                class="rg-datatable elevation-1"
                                :footer-props="{
                                itemsPerPageOptions: [10, 20, 30, 40, 50, 100, 1500],
                                showFirstLastPage: true
                                }"
                                mobile-breakpoint="10"
                                show-select
                                v-model="selected"
                                item-key="id"
                                @update:options="onTableOptionsChange"
                                >
                                
                                    <template v-slot:item.customer_phone_number="{ item }">
                                        <span :style="((item.archived == 1) ? 'text-decoration: line-through;' : '')"><a href="javascript: void(0);" @click="filterBy(item.customer_phone_number)">{{ item.customer_phone_number }}</a></span>

                                        <div v-show="item.lead_id">
                                            <strong>Lead ID:</strong> {{ item.lead_id }}
                                        </div>
                                    </template>
                                
                                    <template v-slot:item.to="{ item }">
                                        {{ item.to || "-" }}
                                    </template>

                                    <template v-slot:item.lead_category="{ item }">
                                        <span v-if="item.lead_category">
                                            {{ item.lead_category.replace(/\_/g, " ") }}
                                        </span>

                                        <span v-if="!item.lead_category">
                                            N/A
                                        </span>
                                    </template>

                                    <template v-slot:item.sources="{ item }">
                                        <div class="flex items-center gap-2">

                                        <div class="flex items-center gap-2">
                                        <v-tooltip v-for="p in normalizedProviders(item)" :key="p.key" top color="primary">
                                        <template #activator="{ on, attrs }">
                                        <img
                                        v-bind="attrs"
                                        v-on="on"
                                        :src="p.src"
                                        :alt="p.title"
                                        class="rg-channel-icon"
                                        @click="p.onClick && p.onClick(item)"
                                        :style="((me && me.is_medical) ? 'cursor: initial;' : 'cursor: pointer;') + ((p.title == 'AI' || p.title == 'Web Chat') ? 'width: 52px; height: 52px; margin-left: -10px;' : '')"
                                        />
                                        </template>
                                        <span>{{ p.title }}</span>
                                        </v-tooltip>
                                        </div>
                                        </div>
                                    </template>

                                    <template v-slot:item.lead_type="{ item }">
                                        <div class="flex items-center gap-2">


                                        <!-- Modality chip (Call / Message / Booking) -->
                                        <span class="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-slate-300 ml-1" style="background-color: #CCCCCC;">
                                        <i v-if="item.lead_type == 'PHONE_CALL'" class="mdi mdi-phone"></i>
                                        <i v-else-if="item.lead_type == 'MESSAGE'" class="mdi mdi-message-text-outline"></i>
                                        <i v-else-if="item.sources == 'web'" class="mdi mdi-chat"></i>
                                        <i v-else class="mdi mdi-information-outline"></i>
                                        <span v-if="item.lead_type == 'PHONE_CALL'">Call</span>
                                        <span v-else-if="item.sources == 'web'">CHAT</span>
                                        <span v-else-if="item.lead_type == 'MESSAGE'">Message</span>
                                        <span v-else-if="item.lead_type == 'BOOKING'">Booking</span>
                                        <span v-else>-</span>
                                        </span>
                                        </div>
                                    </template>

                                    <template v-slot:item.lead_creation_date="{ item }">
                                        {{ displayTimestamp(item.lead_creation_date) }}
                                    </template>

                                    <template v-slot:item.updated_at="{ item }">
                                        {{ displayTimestamp(item.updated_at) }}
                                    </template>

                                    <template v-slot:item.responded_time="{ item }">
                                        <span v-if="item.responded_time !== NULL && item.responded_time !== -1">
                                            <span v-if="item.responded_time > 1000">
                                                {{ parseInt(item.responded_time / 60) }} minutes
                                            </span>
                                            <span v-else>
                                                {{ item.responded_time }} seconds
                                            </span>
                                        </span>
                                        <span v-else>N/A</span>
                                    </template>
                                    
                                    <template v-slot:item.geo="{ item }">
                                        <span v-if="item.geo">
                                            {{ item.geo.split(',')[0] }}
                                        </span>
                                        <span v-else>
                                            N/A
                                        </span>
                                    </template>

                                    <template v-slot:item.job_type="{ item }">
                                        <span v-if="item.job_type">
                                            {{ item.job_type.replace(/\_/g, " ").toLowerCase().replace(/\b[a-z]/g, function(letter) { return letter.toUpperCase(); }) }}
                                        </span>
                                        <span v-else>
                                            N/A
                                        </span>
                                    </template>

                                    <template v-slot:item.from="{ item }">
                                        {{ formatPhoneNumber(item.from) }}
                                    </template>

                                    <template v-slot:item.customer_name="{ item }">
                                        <div :class="'lsa-show-customer-name lsa-show-customer-name-' + item.id">
                                            <a href="javascript: void(0);" @click="showEditCustomerName(item)">{{ item.customer_name }}<i v-show="$store.state.auth.owner" class="mdi mdi-pencil-outline ml-2"></i></a>
                                        </div>
                                        <div :class="'lsa-edit-customer-name lsa-edit-customer-name-' + item.id" style="display: none; position: relative;">
                                            <input type="text" :value="item.customer_name" style="padding: 5px; border: solid 1px #CCCCCC; width: 100px;" />
                                            <div style="position: absolute; margin-top: -22px; right: -31px;">
                                                <a href="javascript: void(0);" style="color: #3EBB80 !important;" @click="editCustomerName(item)"><i class="mdi mdi-check"></i></a>
                                                <a href="javascript: void(0);" class="" style="color: #E53F71 !important;" @click="cancelEditCustomerName(item)"><i class="mdi mdi-close"></i></a>
                                            </div>
                                            <div style="clear: both;"></div>
                                        </div>
                                    </template>

                                    <template v-slot:item.address="{ item }">
                                        <div :class="'lsa-show-address lsa-show-address-' + item.id">
                                            <a href="javascript: void(0);" @click="showEditAddress(item)">{{ item.address }}<i v-show="$store.state.auth.owner" class="mdi mdi-pencil-outline ml-2"></i></a>
                                        </div>
                                        <div :class="'lsa-edit-address lsa-edit-address-' + item.id" style="display: none; position: relative;">
                                            <input type="text" :value="item.address" style="padding: 5px; border: solid 1px #CCCCCC; width: 100px;" />
                                            <div style="position: absolute; margin-top: -22px; right: -31px;">
                                                <a href="javascript: void(0);" style="color: #3EBB80 !important;" @click="editAddress(item)"><i class="mdi mdi-check"></i></a>
                                                <a href="javascript: void(0);" class="" style="color: #E53F71 !important;" @click="cancelEditAddress(item)"><i class="mdi mdi-close"></i></a>
                                            </div>
                                            <div style="clear: both;"></div>
                                        </div>
                                    </template>

                                    <template v-slot:item.value="{ item }">
                                        <div :class="'lsa-show-value lsa-show-value-' + item.id">
                                            <a href="javascript: void(0);" @click="showEditValue(item)">${{ item.value }}<i v-show="$store.state.auth.owner" class="mdi mdi-pencil-outline ml-2"></i></a>
                                        </div>
                                        <div :class="'lsa-edit-value lsa-edit-value-' + item.id" style="display: none; position: relative;">
                                            <input type="text" :value="((item.value > 0) ? item.value : me.settings.customer_value)" style="padding: 5px; border: solid 1px #CCCCCC; width: 100px;" />
                                            <div style="position: absolute; margin-top: -22px; right: -31px;">
                                                <a href="javascript: void(0);" style="color: #3EBB80 !important;" @click="editValue(item)"><i class="mdi mdi-check"></i></a>
                                                <a href="javascript: void(0);" class="" style="color: #E53F71 !important;" @click="cancelEditValue(item)"><i class="mdi mdi-close"></i></a>
                                            </div>
                                            <div style="clear: both;"></div>
                                        </div>
                                    </template>

                                    <template v-slot:item.tag="{ item }">
                                        <div class="pt-2 pb-2">
                                            <span v-for="(tag, index_tag) in item.tag" :key="'tag-' + index_tag" class="pr-2 pb-2">
                                                <v-chip v-if="tag == 0" class="mb-1 dark">
                                                    <span style="font-size: 12px;">Not Set</span>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 1" color="#3EBB80">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Existing Customer</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 2" color="#44468F">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Missed Call</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 3" color="#FFB443" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Opportunity</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 4" color="#2477F6" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Meeting Scheduled</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 5" color="#E53F71">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Became Customer</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Signed'" color="#2137cb" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Signed</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Booked for Consultation'" color="#2bce7f" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Booked for Consultation</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Declined/Not a lead'" color="#aa242b" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Declined/Not a lead</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Wrong Number'" color="#de2f4d" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Wrong Number</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Auto Credited'" color="#338108" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Auto Credited</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'No Response'" color="#3f3f3f" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">No Response</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Existing Client'" color="#4ad25a" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Existing Client</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Failed Sign Up'" color="#830934" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Failed Sign Up</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Following Up/Working on this one'" color="#9418af" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Following Up/Working on this one</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'E-Doc sent not signed'" color="#5a3a69" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">E-Doc sent not signed</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Booked to Service'" color="#2bce7f" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Booked to Service</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Booked for Appointment'" color="#1921ba" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Booked for Appointment</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Cancelled'" color="#c6ab24">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Cancelled</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Complete'" color="#1921ba">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Complete</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Incomplete'" color="#c6ab24">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Incomplete</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'AI Test Call'" color="#000000">
                                                    <span style="font-size: 12px; color: #FFFFFF;">AI Test Call</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Duplicate Call'" color="#6750D7">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Duplicate Call</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag != 0 && tag != 1 && tag != 2 && tag != 3 && tag != 4 && tag != 5
                                                    && tag != 'Signed'
                                                    && tag != 'Booked for Consultation'
                                                    && tag != 'Declined/Not a lead'
                                                    && tag != 'Wrong Number'
                                                    && tag != 'Auto Credited'
                                                    && tag != 'No Response'
                                                    && tag != 'Existing Client'
                                                    && tag != 'Failed Sign Up'
                                                    && tag != 'Following Up/Working on this one'
                                                    && tag != 'E-Doc sent not signed'
                                                    && tag != 'Booked to Service'
                                                    && tag != 'Booked for Appointment'
                                                    && tag != 'Cancelled'
                                                    && tag != 'Complete'
                                                    && tag != 'Incomplete'
                                                    && tag != 'AI Test Call'
                                                    && tag != 'Duplicate Call'
                                                
                                                " :color="getCustomTagColor(tag)">
                                                    <span style="font-size: 12px; color: #FFFFFF;">{{ tag }}</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>
                                            </span>
                                        </div>

                                        <v-menu
                                            
                                            

                                                bottom
                                                right

                                                nudge-bottom='25'
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" color="green" v-bind="attrs" v-on="on" :ripple="false" small class="ml-1">mdi-plus</v-icon>
                                            </template>

                                            <v-list class="table-menu-actions p-2" style="max-height: 500px; overflow-y: auto;">
                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #44468F;" @click="setTag(item, 2);">Missed Call</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #FFB443;" @click="setTag(item, 3);">Opportunity</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #2477F6;" @click="setTag(item, 4);">Meeting Scheduled</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #E53F71;" @click="setTag(item, 5);">Became Customer</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #3EBB80;" @click="setTag(item, 1);">Existing Customer</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #2137cb;" @click="setTag(item, 'Signed');">Signed</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #2bce7f;" @click="setTag(item, 'Booked for Consultation');">Booked for Consultation</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #aa242b;" @click="setTag(item, 'Declined/Not a lead');">Declined/Not a lead</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #de2f4d;" @click="setTag(item, 'Wrong Number');">Wrong Number</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #338108;" @click="setTag(item, 'Auto Credited');">Auto Credited</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #3f3f3f;" @click="setTag(item, 'No Response');">No Response</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #4ad25a;" @click="setTag(item, 'Existing Client');">Existing Client</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #830934;" @click="setTag(item, 'Failed Sign Up');">Failed Sign Up</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #9418af;" @click="setTag(item, 'Following Up/Working on this one');">Following Up/Working on this one</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #5a3a69;" @click="setTag(item, 'E-Doc sent not signed');">E-Doc sent not signed</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #2bce7f;" @click="setTag(item, 'Booked to Service');">Booked to Service</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #1921ba;" @click="setTag(item, 'Booked for Appointment');">Booked for Appointment</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #c6ab24;" @click="setTag(item, 'Cancelled');">Cancelled</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #1921ba;" @click="setTag(item, 'Complete');">Complete</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #c6ab24;" @click="setTag(item, 'Incomplete');">Incomplete</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #000000;" @click="setTag(item, 'AI Test Call');">AI Test Call</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #6750D7;" @click="setTag(item, 'Duplicate Call');">Duplicate Call</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item v-for="(custom_tag, tag_index) in custom_tags" :key="'custom-tag-' + tag_index" class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" :style="'color: ' + custom_tag.color + ';'" @click="setTag(item, custom_tag.tag);">{{ custom_tag.tag }}</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);" @click="showAddTag = true">+ Add Tag</a></v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </template>

                                    <template v-slot:item.qualify_status="{ item }">
                                        <v-chip
                                                small
                                                color="gray lighten-5"
                                                text-color="gray lighten-1"
                                            
                                                v-if="item.qualify_status == 0"
                                        >
                                            Not Set
                                        </v-chip>

                                        <v-chip
                                                small
                                                color="green lighten-5"
                                                text-color="green lighten-1"
                                            
                                                v-if="item.qualify_status == 1"
                                        >
                                            Qualified
                                        </v-chip>

                                        <v-chip
                                                small
                                                color="red lighten-5"
                                                text-color="red lighten-1"
                                            
                                                v-if="item.qualify_status == -1"
                                        >
                                            Unqualified
                                        </v-chip>

                                        <v-chip
                                                small
                                                color="red darken-2"
                                                text-color="white"
                                            
                                                v-if="item.qualify_status == 2"
                                        >
                                            Spam
                                        </v-chip>

                                        <v-chip v-if="item.qualify_status != 0 && item.qualify_status != 1 && item.qualify_status != 2 && item.qualify_status != -1" :color="getCustomStatusColor(item.qualify_status)"
                                            small
                                            text-color="white"
                                        >
                                            {{ item.qualify_status }}
                                        </v-chip>

                                        <v-menu

                                            

                                                bottom
                                                right

                                                nudge-bottom='25'
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" color="green" v-bind="attrs" v-on="on" :ripple="false" small class="ml-1">mdi-plus</v-icon>
                                            </template>

                                            <v-list class="table-menu-actions">
                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);" @click="item.qualify_status = 1; setQualifyStatus(item, 1);">Qualified</a>
                                                    </v-list-item-title>
                                                </v-list-item>
                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);" @click="item.qualify_status = -1; setQualifyStatus(item, -1);">Unqualified</a>
                                                    </v-list-item-title>
                                                </v-list-item>
                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);" @click="item.qualify_status = 2; setQualifyStatus(item, 2);">Spam</a>
                                                    </v-list-item-title>
                                                </v-list-item>
                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);" @click="item.qualify_status = 0; setQualifyStatus(item, 0);">Not Set</a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item v-for="(custom_status, status_index) in custom_statuses" :key="'custom-status-' + status_index" class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" :style="'color: ' + custom_status.color + ';'" @click="item.qualify_status = custom_status.status; setQualifyStatus(item, custom_status.status);">{{ custom_status.status }}</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);" @click="showAddStatus = true">+ Add Status</a></v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </template>

                                    <!-- NEW: Google LSA Rating column -->
                                    <template v-slot:item.ai_rating="{ item }">
                                    <div class="flex items-center gap-2">
                                        <!-- If already rated, show a green check and the final rating -->
                                        <div v-if="item.rated_at" class="flex items-center gap-2">
                                        
                                        <i v-show="item.satisfaction == 'SATISFIED' || item.satisfaction == 'VERY_SATISFIED' || item.satisfaction == 'NEUTRAL'" class="mdi mdi-check-circle" style="color: green; font-size: 20px;"></i>
                                        <i v-show="item.satisfaction == 'DISSATISFIED' || item.satisfaction == 'VERY_DISSATISFIED'" class="mdi mdi-close-circle" style="color: red; font-size: 20px;"></i>

                                        <span class="text-sm">
                                            <strong>{{ satisfactionLabelByTexts(item.satisfaction) }}</strong>
                                            <span v-if="item.reason"> · {{ reasonLabel(item.reason) }}</span>
                                        </span>
                                        </div>

                                        <!-- Not rated yet: show AI suggestion / actions -->
                                        <div v-else class="flex items-center gap-2">
                                        <v-chip small color="blue lighten-5" text-color="blue lighten-1" v-if="aiSuggestionById[item.id] && !aiLoadingById[item.id]">
                                            {{ aiSuggestionById[item.id].satisfactionLabel }}
                                            <span v-if="aiSuggestionById[item.id].reasonLabel"> · {{ aiSuggestionById[item.id].reasonLabel }}</span>
                                        </v-chip>

                                        <v-btn class="ai-suggestion-generate" small depressed @click="generateAiSuggestion(item)" :loading="aiLoadingById[item.id]" v-if="!aiSuggestionById[item.id]">
                                            Generate AI Suggestion
                                        </v-btn>

                                        <v-btn icon @click="regenerateAiSuggestion(item)" :loading="aiLoadingById[item.id]" v-if="aiSuggestionById[item.id]">
                                            <v-icon small>mdi-reload</v-icon>
                                        </v-btn>

                                        <v-tooltip top color="primary" v-if="aiSuggestionById[item.id]">
                                            <template #activator="{ on, attrs }">
                                            <v-btn small color="green" dark v-bind="attrs" v-on="on" @click="acceptAiSuggestion(item)">
                                                Accept
                                            </v-btn>
                                            </template>
                                            <span>Open modal with fields pre-filled by AI</span>
                                        </v-tooltip>

                                        <!-- Fallback manual rating (opens your existing modal) -->
                                        <v-btn small outlined color="grey" @click="$refs.RateLeadModal.show(); $refs.RateLeadModal.lead = item; $refs.RateLeadModal.selectedSatisfaction = null; $refs.RateLeadModal.selectedReason = null; $refs.RateLeadModal.additionalComments = '';">
                                            Rate Lead
                                        </v-btn>
                                        </div>
                                    </div>
                                    </template>

                                    <template v-slot:item.intake_performance="{ item }">
                                        <div v-if="item.sources.indexOf('lsa') != -1 && item.sources.indexOf('bland') == -1" class="flex items-center gap-2">
                                            <!-- If already rated, show a green check and the final rating -->
                                            <div v-if="item.intake_performance" class="flex items-center gap-2">
                                                <v-tooltip bottom content-class="intake-tooltip">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-chip
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            small
                                                            :color="item.intake_performance.color"
                                                            dark
                                                            class="font-weight-bold"
                                                        >
                                                            {{ item.intake_performance.rating }}
                                                        </v-chip>
                                                    </template>

                                                    <span class="tooltip-text">
                                                        {{ item.intake_performance.explanation }}
                                                    </span>
                                                </v-tooltip>
                                            </div>

                                            <!-- Not rated yet: show AI suggestion / actions -->
                                            <div v-else class="flex items-center gap-2">
                                                <v-btn small depressed @click="generateAiIntakePerformance(item)" :loading="aiLoadingInakePerformanceById[item.id]">
                                                    Generate
                                                </v-btn>
                                            </div>
                                        </div>
                                        <div v-else>N/A</div>
                                    </template>

                                    <template v-slot:item.ai_performance="{ item }">
                                        <div v-if="item.sources.indexOf('bland') != -1" class="flex items-center gap-2">
                                            <!-- If already rated, show a green check and the final rating -->
                                            <div v-if="item.ai_performance" class="flex items-center gap-2">
                                                <v-tooltip bottom content-class="intake-tooltip">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-chip
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            small
                                                            :color="item.ai_performance.color"
                                                            dark
                                                            class="font-weight-bold"
                                                        >
                                                            {{ item.ai_performance.rating }}
                                                        </v-chip>
                                                    </template>

                                                    <span class="tooltip-text">
                                                        {{ item.ai_performance.explanation }}
                                                    </span>
                                                </v-tooltip>
                                            </div>

                                            <!-- Not rated yet: show AI suggestion / actions -->
                                            <div v-else class="flex items-center gap-2">
                                                <v-btn small depressed @click="generateAiPerformance(item)" :loading="aiLoadingAiPerformanceById[item.id]">
                                                    Generate
                                                </v-btn>
                                            </div>
                                        </div>
                                        <div v-else>N/A</div>
                                    </template>

                                    <template v-slot:item.lead_quality="{ item }">
                                        <div class="flex items-center gap-2">
                                            <!-- If already rated, show a green check and the final rating -->
                                            <div v-if="item.lead_quality" class="flex items-center gap-2">
                                                <v-tooltip bottom content-class="intake-tooltip">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-chip
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            small
                                                            :color="item.lead_quality.color"
                                                            dark
                                                            class="font-weight-bold"
                                                        >
                                                            {{ item.lead_quality.rating }}
                                                        </v-chip>
                                                    </template>

                                                    <span class="tooltip-text">
                                                        {{ item.lead_quality.explanation }}
                                                    </span>
                                                </v-tooltip>
                                            </div>

                                            <!-- Not rated yet: show AI suggestion / actions -->
                                            <div v-else class="flex items-center gap-2">
                                                <v-btn small depressed @click="generateLeadQualityPerformance(item)" :loading="aiLoadingLeadQualityPerformanceById[item.id]">
                                                    Generate
                                                </v-btn>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-slot:item.id="{ item }">

                                        <div style="position: relative;">

                                            <a href="javascript: void(0);" @click="notes_lead = item; show_notes_dialog = true"><i class="mdi mdi-comment-multiple-outline" style="font-size: 16px;"></i></a>

                                            <i v-show="item.rated_at" class="mdi mdi-check-circle" style="color: green; font-size: 20px;"></i>

                                            <span v-if="item.notes.length > 0" style="width: 16px;
                                                height: 16px;
                                                line-height: 17px;
                                                font-size: 10px;
                                                background: rgb(255, 112, 67);
                                                color: rgb(255, 255, 255);
                                                padding: 0px !important;
                                                border-radius: 100%;
                                                position: absolute;
                                                font-weight: 600;
                                                text-align: center;
                                                margin-top: -3px;
                                                margin-left: -6px;">{{ item.notes.length }}</span>

                                            &nbsp; &nbsp;

                                            <v-menu
                                                    bottom
                                                    right

                                                    nudge-bottom='25'
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon color="green" v-bind="attrs" v-on="on" :ripple="false" small class="ml-1">mdi-dots-vertical</v-icon>
                                                </template>

                                                <v-list class="table-menu-actions">
                                                    <v-list-item class="hover:bg-gray-200">
                                                        <v-list-item-title v-show="item.archived == 0"><a href="javascript: void(0);" @click="archiveLead(item)"><span
                                                            class="table-menu-action-icon"><i
                                                            class="mdi mdi-archive-outline"></i></span> Archive</a>
                                                        </v-list-item-title>
                                                        <v-list-item-title v-show="item.archived == 1"><a href="javascript: void(0);" @click="unArchiveLead(item)"><span
                                                            class="table-menu-action-icon"><i
                                                            class="mdi mdi-package-up"></i></span> Unarchive</a>
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item class="hover:bg-gray-200">
                                                        <v-list-item-title v-show="item.sources.indexOf('lsa') != -1"><a href="javascript: void(0);" @click="$refs.RateLeadModal.show(); $refs.RateLeadModal.lead = item; $refs.RateLeadModal.selectedSatisfaction = null; $refs.RateLeadModal.selectedReason = null; $refs.RateLeadModal.additionalComments = '';"><span
                                                            class="table-menu-action-icon"><i
                                                            class="mdi mdi-star-outline"></i></span> <span v-if="item.rated_at">Lead rated already!</span><span v-else>Rate this lead</span></a>
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </div>
                                    </template>
                                </v-data-table>
                            </div>
                        </div>
                    </v-card>
                </div>
            </template>
        
    </panel-navigation>
</template>

<script>

import { mapState } from 'vuex'
import $ from 'jquery';
import PanelNavigation from '@/components/PanelNavigation.vue'
import InboxThread from '@/views/panel/InboxThread.vue'
import RateLeadModal from  "@/views/panel/Call/Rate-Lead-Modal.vue"
import axios from 'axios'
import moment from 'moment'
import DialogBuyNumber from '@/components/dialogs/integrations/buyNumber.vue'
import DialogRequestReview from '@/components/dialogs/reviews/requestReview.vue'
import { mixin as clickaway } from 'vue-clickaway';
import ReinforcementLearning from '../../../components/reusable/ReinforcementLearning.vue';

export default {
mixins: [ clickaway ],
    components: {
        RateLeadModal,
        PanelNavigation,
        InboxThread,
        DialogBuyNumber,
        DialogRequestReview,
        ReinforcementLearning
    },
    computed: {
      ...mapState({
          me: (state) => state.me.me,
          profile: (state) => state.me.profile,
      }),
      allowedReasons() {
            // Map these to your modal’s real reason values/labels if they differ.
            // You can extend this list anytime; the AI will match to the closest.
            return [
            'Correct Lead',
            'Wrong Number',
            'Spam',
            'Low Quality Lead',
            'Not Relevant',
            'Existing Customer',
            'Repeat Caller',
            'Voicemail / No Answer',
            'Test Call',
            'Other'
            ]
        },

        computedHeaders() {
          if (!this.me) return []; // fallback if user not loaded

          // Special email rule
          if (this.me.email === 'sue@chiefmarketingoutsider.com') {
            return this.headers_custom_comfort;
          }

          // New rule: if me.id is in the list, use headers_with_rating
          // const ratingUsers = [983, 1042, 1397, 1600];
          // if (ratingUsers.includes(this.me.id)) {
          //   return this.headers_with_rating;
          // }

          // Default based on Accelerate / DIY
          return this.isAccelerate() ? this.headers_with_rating : this.diy_headers;
        }
    },

data() {
    return {
        selected: [],
        selectedIds: [],
        selectedPhoneNumbers: [],

        messages: [],
        loading: true,
        thisProc: false,
        show_picker: false,
        
        date_filter: [
              moment().subtract(60, 'days').format('YYYY-MM-DD'),
              moment().format('YYYY-MM-DD')
        ],

        archived_filter: 'Show Unarchived',

        channel_filter: '',
        lead_type_filter: '',
        charge_status_filter: '',

        all_time: 0,

        selected_date_text: "Last 60 days",
        
        search: "",

        showAddTag: false,
        showAddStatus: false,

        custom_tags: [],
        custom_statuses: [],

        tags_items: [{
                index: 0,
                text: 'Not Set'
            },{
                index: 1,
                text: 'Existing Customer'
            },{
                index: 2,
                text: 'Missed Call'
            },{
                index: 3,
                text: 'Opportunity'
            },{
                index: 4,
                text: 'Meeting Scheduled'
            },{
                index: 5,
                text: 'Became Customer'
            },{
                index: 'Signed',
                text: 'Signed'
            }
            ,{
                index: 'Booked for Consultation',
                text: 'Booked for Consultation'
            }
            ,{
                index: 'Declined/Not a lead',
                text: 'Declined/Not a lead'
            }
            ,{
                index: 'Wrong Number',
                text: 'Wrong Number'
            },{
                index: 'Auto Credited',
                text: 'Auto Credited'
            }
            ,{
                index: 'No Response',
                text: 'No Response'
            }
            ,{
                index: 'Existing Client',
                text: 'Existing Client'
            }
            ,{
                index: 'Failed Sign Up',
                text: 'Failed Sign Up'
            }
            ,{
                index: 'Following Up/Working on this one',
                text: 'Following Up/Working on this one'
            }
            ,{
                index: 'E-Doc sent not signed',
                text: 'E-Doc sent not signed'
            }
            ,{
                index: 'Booked to Service',
                text: 'Booked to Service'
            }
            ,{
                index: 'Booked for Appointment',
                text: 'Booked for Appointment'
            }
            ,{
                index: 'Cancelled',
                text: 'Cancelled'
            }, {
                index: 'Complete',
                text: 'Complete'
            }, {
                index: 'Incomplete',
                text: 'Incomplete'
            }, {
                index: 'AI Test Call',
                text: 'AI Test Call'
            }, {
                index: 'Duplicate Call',
                text: 'Duplicate Call'
            },
        ],

        qualify_status_items: [{
            index: 0,
            text: 'Not Set'
        },{
            index: 1,
            text: 'Qualified'
        },{
            index: -1,
            text: 'Unqualified'
        },{
            index: 2,
            text: 'Spam'
        }],

        tag: "",
        qualify_status: "",

        headers: [
            { text: 'Lead Details', value: 'customer_phone_number' },
            { text: 'AI Number', value: 'to' },
            { text: 'Channels', value: 'sources' },
            { text: '', value: 'lead_type' },
            { text: 'Business Category', value: 'lead_category' },
            // { text: 'AI Feedback', value: 'ai_feedback', width: 140 },
            { text: 'Creation Date', value: 'lead_creation_date', width: 200 },
            { text: 'Last Updated', value: 'updated_at', width: 200 },
            { text: 'Response Time', value: 'responded_time' },
            { text: 'Location', value: 'geo' },
            { text: 'Job Type', value: 'job_type' },
            { text: 'Charge Status', value: 'charge_status' },
            { text: 'Credit Status', value: 'dispute_status' },
            { text: 'Value', value: 'value' },
            { text: 'Tags', value: 'tag' },
            { text: 'Status', value: 'qualify_status' },
            { text: '', value: 'id' }
        ],

        headers_with_rating: [
            { text: 'Lead Details', value: 'customer_phone_number' },
            { text: 'AI Number', value: 'to' },
            { text: 'Channels', value: 'sources' },
            { text: '', value: 'lead_type' },
            { text: 'Business Category', value: 'lead_category' },
            // { text: 'AI Feedback', value: 'ai_feedback', width: 140 },
            { text: 'Creation Date', value: 'lead_creation_date', width: 200 },
            { text: 'Last Updated', value: 'updated_at', width: 200 },
            { text: 'Response Time', value: 'responded_time' },
            { text: 'Location', value: 'geo' },
            { text: 'Job Type', value: 'job_type' },
            { text: 'Charge Status', value: 'charge_status' },
            { text: 'Credit Status', value: 'dispute_status' },
            { text: 'Value', value: 'value' },
            { text: 'Google LSA Rating', value: 'ai_rating', align: 'start', sortable: false, width: 260 },
            { text: 'Tags', value: 'tag' },
            { text: 'Status', value: 'qualify_status' },
            { text: '', value: 'id' }
        ],

        diy_headers: [
            { text: 'Lead Details', value: 'customer_phone_number' },
            { text: 'AI Number', value: 'to' },
            { text: 'Channels', value: 'sources' },
            { text: '', value: 'lead_type' },
            { text: 'Business Category', value: 'lead_category' },
            // { text: 'AI Feedback', value: 'ai_feedback', width: 140 },
            { text: 'Creation Date', value: 'lead_creation_date', width: 200 },
            { text: 'Last Updated', value: 'updated_at', width: 200 },
            { text: 'Response Time', value: 'responded_time' },
            { text: 'Location', value: 'geo' },
            { text: 'Job Type', value: 'job_type' },
            { text: 'Charge Status', value: 'charge_status' },
            { text: 'Credit Status', value: 'dispute_status' },
            { text: 'Value', value: 'value' },
            { text: 'Tags', value: 'tag' },
            { text: 'Google LSA Rating', value: 'ai_rating', align: 'start', sortable: false, width: 260 },
            { text: 'Intake Performance', value: 'intake_performance', align: 'start', sortable: false, width: 260 },
            { text: 'AI Performance', value: 'ai_performance', align: 'start', sortable: false, width: 260 },
            { text: 'Lead Quality', value: 'lead_quality', align: 'start', sortable: false, width: 260 },
            { text: '', value: 'id' }
        ],

        headers_custom_comfort: [
            { text: 'Lead Details', value: 'customer_phone_number' },
            { text: 'AI Number', value: 'to' },
            { text: 'Name', value: 'customer_name' },
            { text: 'Address', value: 'address' },
            { text: 'Channels', value: 'sources' },
            { text: '', value: 'lead_type' },
            { text: 'Business Category', value: 'lead_category' },
            { text: 'Date', value: 'lead_creation_date', width: 200 },
            { text: 'Location', value: 'geo' },
            // { text: 'Charge Status', value: 'charge_status' },
            { text: 'Job Type', value: 'job_type' },
            { text: 'Charge Status', value: 'charge_status' },
            { text: 'Credit Status', value: 'dispute_status' },
            { text: 'Value', value: 'value' },
            { text: 'Tags', value: 'tag' },
            { text: 'Status', value: 'qualify_status' },
            { text: '', value: 'id' }
        ],

        new_note: "",
        show_notes_dialog: false,
        notes_lead: null,
        savingNote: false,

        exporting: false,

        new_tag: "",
        new_tag_color: "#000000",
        savingTag: false,

        new_status: "",
        new_status_color: "#000000",
        savingStatus: false,

        showCallRailRecording: false,
        loading_callrail_recording: true,
        callrail_recording_data: {},

        showBlandRecording: false,
        loading_bland_recording: true,
        bland_recording_data: {},

        showLsaRecordings: false,
        loading_lsa_recordings: true,
        lsa_recording_data: {},

        showLsaMessages: false,
        loading_lsa_messages: true,
        lsa_messages_displayed: [],
        lsa_item: null,

        new_lsa_message: "",
        sendingLsaMessage: false,
        lsa_messages_lead: null,

        new_ai_message: "",
        sendingAiMessage: false,
        ai_messages_lead: null,

        lsa_leads_count: 0,
        ai_leads_count: 0,
        ai_leads_count_msg: 0,
        ai_leads_count_voice: 0,
        callrail_leads_count: 0,
        converted_leads_count: 0,
        converted_ai_leads_count: 0,
        converted_human_leads_count: 0,
        booked_leads_count: 0,
        booked_ai_leads_count: 0,
        booked_human_leads_count: 0,

        savingAiFeedback: false,
        
        shouldShowChatConversation: false,
        loading_chat_conversation: false,

        conversations: [
            { id: 1, title: "Call with John Doe", transcript: "Hello, this is John from XYZ..." },
            { id: 2, title: "Call with Jane Smith", transcript: "Hi, this is Jane. I'm calling about..." },
        ],
        selectedConversations: [],
        criteria: [
            { question: "Did the agent greet the customer?", type: "yes_no" },
            { question: "What is the customer’s name?", type: "string" },
            { question: "Was a phone number mentioned?", type: "phone" },
            { question: "Did the agent confirm the customer's issue?", type: "yes_no" },
            { question: "What was the resolution offered by the agent?", type: "string" },
            { question: "What was the overall sentiment of the conversation?", type: "sentiment" },
        ],
        results: {
            summary: null,
            calls: [],
        },
        selectedCallIndex: '',
        loadingAnalysys: false,
        showResetButton: false,

        showFullLeadDetailsMobile: false,
        showFullLeadDetailsMobileKey: 0,

        // ...
        aiSuggestionById: {}, // { [leadId]: { satisfaction, reason, comment, satisfactionLabel, reasonLabel } }
        aiLoadingById: {},    // { [leadId]: boolean }
        aiLoadingInakePerformanceById: {},    // { [leadId]: boolean }
        aiLoadingAiPerformanceById: {},    // { [leadId]: boolean }
        aiLoadingLeadQualityPerformanceById: {},    // { [leadId]: boolean }

        showExtraFilters: false,

        respond_as: "AI Agent",

        requestedSuggestions: new Set()
    }
},
methods: {
    markAsGoodCallsForSurvey() {
        this.selected = [];

        this.$swal({
            title: "Saved",
            text: "Selected calls will be used as knowledge for good calls when submitting survey!",
            showCancelButton: false,
        });
    },
    
    satisfactionLabel(value) {
        const map = {
            1: 'Very Satisfied',
            2: 'Satisfied',
            3: 'Neutral',
            4: 'Unsatisfied',
            5: 'Very Unsatisfied'
        };
        return map[value] || 'Not Set';
    },

    satisfactionLabelByTexts(value) {
        const map = {
            "VERY_SATISFIED": 'Very Satisfied',
            "SATISFIED": 'Satisfied',
            "NEUTRAL": 'Neutral',
            "DISSATISFIED": 'Unsatisfied',
            "VERY_DISSATISFIED": 'Very Unsatisfied'
        };
        return map[value] || 'Not Set';
    },

    reasonLabel(reason) {
        // If you store reasons as strings already, just return them.
        // If your backend uses codes, map those codes to labels here.
        return reason || '—';
    },

    async generateAiSuggestion(item) {
        this.$set(this.aiLoadingById, item.id, true);
        try {
        let transcript = item.lsa_transcription;

        if (!transcript)
            transcript = item.lsa_messages;

        const suggestion = await this.callOpenAIForRating(transcript);

        // Normalize + store
        const normalized = this.normalizeSuggestion(suggestion);
        this.$set(this.aiSuggestionById, item.id, normalized);
        } catch (e) {
        console.error('AI suggestion failed:', e);
        this.$toast && this.$toast.error('Could not generate AI suggestion.');
        } finally {
        this.$set(this.aiLoadingById, item.id, false);
        }
    },

    async regenerateAiSuggestion(item) {
        return this.generateAiSuggestion(item);
    },

    acceptAiSuggestion(item) {
        const sug = this.aiSuggestionById[item.id];

        console.log('sug', sug);

        let satisfactionOptions = [
            { emoji: '😃', value: 'VERY_SATISFIED', label: 'Very satisfied.' },
            { emoji: '🙂', value: 'SATISFIED', label: 'Somewhat satisfied.' },
            { emoji: '😐', value: 'NEUTRAL', label: 'Neither satisfied nor dissatisfied.' },
            { emoji: '🙁', value: 'DISSATISFIED', label: 'Somewhat dissatisfied.' },
            { emoji: '☹️', value: 'VERY_DISSATISFIED', label: 'Very dissatisfied.' }
        ];

        if (!sug) return;

        // Open your existing modal and pre-fill fields
        const modal = this.$refs.RateLeadModal;
        modal.show();
        modal.lead = item;
        modal.selectedSatisfaction = satisfactionOptions[sug.satisfaction - 1].value || null;
        modal.selectedReason = sug.reason || null;
        modal.additionalComments = sug.comment || '';
    },

    extractTranscript(bland) {
        // Handles either stringified JSON or direct array
        try {
        const j = (typeof bland === 'string') ? JSON.parse(bland) : bland;
        if (Array.isArray(j)) {
            // Join all speaker turns into a single plain text with roles
            return j.map(t => `${t.speaker || ''}: ${t.text || ''}`).join('\n');
        }
        // If object with messages array, etc:
        if (j && Array.isArray(j.messages)) {
            return j.messages.map(m => `${m.speaker || m.from || ''}: ${m.text || m.body || ''}`).join('\n');
        }
        // Fallback: stringify
        return JSON.stringify(j);
        } catch (e) {
        return String(bland || '');
        }
    },

    normalizeSuggestion(s) {
        // Ensure we have 1–5
        let satisfaction = Number(s.satisfaction);
        if (!(satisfaction >= 1 && satisfaction <= 5)) satisfaction = 3;

        // Match reason against allowedReasons (case-insensitive fuzzy startsWith/contains)
        const input = (s.reason || '').toLowerCase();
        let reason = this.allowedReasons.find(r => r.toLowerCase() === input);
        if (!reason && input) {
        reason = this.allowedReasons.find(r => r.toLowerCase().includes(input)) ||
                this.allowedReasons.find(r => input.includes(r.toLowerCase()));
        }
        if (!reason) reason = 'Other';

        const comment = (s.comment || '').trim().slice(0, 400);

        return {
        satisfaction,
        reason,
        comment,
        satisfactionLabel: this.satisfactionLabel(satisfaction),
        reasonLabel: reason
        };
    },

    async callOpenAIForRating(transcriptPlainText) {
        const user = transcriptPlainText;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/analysys/analyze-survey`, {
            user: user,
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        return response.data;
    },

    async generateAiIntakePerformance(item) {
        this.$set(this.aiLoadingInakePerformanceById, item.id, true);
        try {
        let transcript = item.lsa_transcription;

        if (!transcript)
            transcript = item.lsa_messages;

        const intake_performance = await this.callOpenAIForIntakePerformance(item.id, transcript);

        console.log('intake_performance', intake_performance);

        item.intake_performance = intake_performance;

        } catch (e) {
            console.error('AI suggestion failed:', e);
        } finally {
            this.$set(this.aiLoadingInakePerformanceById, item.id, false);
        }
    },

    async generateAiPerformance(item) {
        this.$set(this.aiLoadingAiPerformanceById, item.id, true);
        try {
        let transcript = item.bland_transcription;

        const ai_performance = await this.callOpenAIForAiPerformance(item.id, transcript);

        console.log('ai_performance', ai_performance);

        item.ai_performance = ai_performance;

        } catch (e) {
            console.error('AI suggestion failed:', e);
        } finally {
            this.$set(this.aiLoadingAiPerformanceById, item.id, false);
        }
    },

    async generateLeadQualityPerformance(item) {
        this.$set(this.aiLoadingLeadQualityPerformanceById, item.id, true);
        try {
        let transcript = item.lsa_transcription;

        if (!transcript)
            transcript = item.lsa_messages;

        if (!transcript)
            transcript = item.bland_transcription;

        const lead_quality = await this.callOpenAIForLeadQualityPerformance(item.id, transcript);

        console.log('lead_quality', lead_quality);

        item.lead_quality = lead_quality;

        } catch (e) {
            console.error('AI suggestion failed:', e);
        } finally {
            this.$set(this.aiLoadingLeadQualityPerformanceById, item.id, false);
        }
    },

    async callOpenAIForIntakePerformance(lead_id, transcriptPlainText) {
        const user = transcriptPlainText;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/analysys/analyze-intake-performance`, {
            user: user,
            lead_id: lead_id
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        return response.data;
    },

    async callOpenAIForAiPerformance(lead_id, transcriptPlainText) {
        const user = transcriptPlainText;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/analysys/analyze-ai-performance`, {
            user: user,
            lead_id: lead_id
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        return response.data;
    },

    async callOpenAIForLeadQualityPerformance(lead_id, transcriptPlainText) {
        const user = transcriptPlainText;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/analysys/analyze-lead-quality`, {
            user: user,
            lead_id: lead_id
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        return response.data;
    },
    
    hasAI(item) {
        const src = (item.sources || '').toLowerCase()
        return src.includes('bland') || src.includes('web')
    },

    normalizedProviders(item) {
        // Build a unique set of providers from item.sources ONLY ONCE
        const src = (item.sources || '').toLowerCase()
        const list = []
        const push = (cond, key, title, srcImg, onClick) => {
        if (cond) list.push({ key, title, src: srcImg, onClick })
        }


        // Important: render EACH provider ONCE. We no longer render separate icons for call/message.
        push(src.includes('lsa'), 'lsa', 'LSA', require('@/assets/images/lsa.webp'), (row) => {
        // prefer messages when lead_type is MESSAGE, else show call recordings
        if (row.lead_type === 'MESSAGE') this.showLsaMessagesFunction(row)
        else this.showLsaCallRecordings(row)
        })


        push(src.includes('callrail'), 'callrail', 'CallRail', require('@/assets/images/callrail.png'), (row) => this.showCallRailRecordingFunction(row))


        push(src.includes('bland'), 'ai', 'AI', require('@/assets/images/bland.png'), (row) => this.showBlandRecordingFunction(row))


        push(src.includes('web'), 'web', 'Web Chat', require('@/assets/images/bland.png'), (row) => this.showChatConversation(row))


        // Avoid duplicate icons added from merged_lead by ONLY using current row sources.
        // If you want to show merged sources too, dedupe by key:
        // const merged = (row.merged_lead?.[0]?.sources || '').toLowerCase()
        // ... add conditionally if not already in list.


        // De-duplicate by key just in case
        const seen = new Set()
        return list.filter(p => (seen.has(p.key) ? false : seen.add(p.key)))
    },

    isSeoTab() {
        return this.$router.currentRoute.name == 'LeadsNewSeo'
    },
    filterBy(text) {
      this.search = text;
      this.getMessages();
      this.showResetButton = ((text == '') ? false : true);
    },

    getHost() {
      return window.location.host;
    },

    isOnlyAi() {
      if (this.me.integrations && this.me.integrations.google_ads && this.me.integrations.google_ads.status == 0 && !this.isAccelerate())
        return true;

      return false;
    },

    isAccelerate() {
        // || this.getHost() == 'zany-space-palm-tree-q9vjg4xr39j97-8080.app.github.dev'
      return this.getHost() == 'lsa.accelerateyourmarketing.com' || this.getHost() == 'zany-space-palm-tree-q9vjg4xr39j97-8080.app.github.dev';
    },

    addCriteria() {
      this.criteria.push({ question: "", type: "yes_no" });
    },

    removeCriterion(index) {
        this.criteria.splice(index, 1);
    },

    async analyze() {
    //   if (!this.selectedConversations.length) {
    //     alert("Please select at least one conversation.");
    //     return;
    //   }

      this.loadingAnalysys = true;
      this.results = [];

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/analysys/analyze`, {
            conversations: this.selectedIds,
            criteria: this.criteria,
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

      this.results = response.data;
      this.loadingAnalysys = false;
    },

    formatFeedback(feedback, type) {
        if (type === 'sentiment') {
        return feedback.replace(/[^A-Za-z]/g, '').toUpperCase();
        }
        return feedback;
    },
    sentimentClass(value) {
        const sentiment = value.toLowerCase();
        if (sentiment.includes("positive")) return "bg-green-100 text-green-800";
        if (sentiment.includes("neutral")) return "bg-yellow-100 text-yellow-800";
        if (sentiment.includes("negative")) return "bg-red-100 text-red-800";
        return "bg-gray-100 text-gray-800";
    },
    passRate(call) {
        const total = call.analysis.length;
        const passed = call.analysis.filter(a => a.pass).length;
        return Math.round((passed / total) * 100);
    },

    acceptNewPrompt() {
        this.$swal({
            title: "Saved",
            text: "New prompt has been applied to your agent!",
            showCancelButton: false,
        });

        this.results = {
            summary: null,
            calls: []
        };
    },

    async translateTexts(conv_type, language) {
        if (conv_type == 'bland') {
            if (this.bland_recording_data.transcription.messages) {
                for (var i in this.bland_recording_data.transcription.messages) {
                    let theMessage = this.bland_recording_data.transcription.messages[i].body;

                    if (!theMessage) {
                        theMessage = this.bland_recording_data.transcription.messages[i].text
                    }

                    if (!theMessage) {
                        theMessage = this.bland_recording_data.transcription.messages[i].message
                    }

                    let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/translate-text`, {
                        source: 'en',
                        target: language,
                        q: theMessage
                    }, {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                        }
                    });


                    this.bland_recording_data.transcription.messages[i].body = response.data.data.translations[0].translatedText;
                    this.bland_recording_data.transcription.messages[i].text = response.data.data.translations[0].translatedText;
                    this.bland_recording_data.transcription.messages[i].message = response.data.data.translations[0].translatedText;
                }
            }
            else {
                for (var i in this.bland_recording_data.transcription) {
                    let theMessage = this.bland_recording_data.transcription[i].body;

                    if (!theMessage) {
                        theMessage = this.bland_recording_data.transcription[i].text
                    }

                    if (!theMessage) {
                        theMessage = this.bland_recording_data.transcription[i].message
                    }

                    let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/translate-text`, {
                        source: 'en',
                        target: language,
                        q: theMessage
                    }, {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                        }
                    });


                    this.bland_recording_data.transcription[i].body = response.data.data.translations[0].translatedText;
                    this.bland_recording_data.transcription[i].text = response.data.data.translations[0].translatedText;
                    this.bland_recording_data.transcription[i].message = response.data.data.translations[0].translatedText;
                }
            }

            this.bland_recording_data = JSON.parse(JSON.stringify(this.bland_recording_data));
        }
    },

    async switchAiResponseEnabled(lead) {
        console.log('lead', lead);

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-ai-response-enabled`, {
            lead_id: lead.id,
            ai_enabled: lead.ai_enabled
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        console.log('response', response);
    },

    async sendLsaReply() {
        this.sendingLsaMessage = true;
        
        let self = this;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/reply-lsa-message`, {
            lead_id: self.lsa_messages_lead.id,
            message: self.new_lsa_message
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        let timezone = this.me.timezone;

        this.lsa_messages_displayed.push({
            event_time: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
            participant_type: 2,
            text: self.new_lsa_message
        });

        this.sendingLsaMessage = false;
        this.new_lsa_message = "";

        setTimeout(function() {
            var objDiv = document.getElementById("lsa-dialog-messages-list");
            objDiv.scrollTop = objDiv.scrollHeight;
        }, 10);
    },

    async sendAiReply() {
        this.sendingAiMessage = true;
        
        let self = this;

        console.log('this.bland_recording_data', this.bland_recording_data);

        if (this.bland_recording_data.sources && this.bland_recording_data.sources.indexOf('lsa') != -1) {
            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/reply-lsa-message`, {
                lead_id: this.bland_recording_data.id,
                message: self.new_ai_message,
                respond_as: this.respond_as
            }, {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                }
            });
        }
        else {
            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/reply-ai-message`, {
                lead_id: self.ai_messages_lead.id,
                message: self.new_ai_message,
                respond_as: this.respond_as
            }, {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                }
            });
        }

        let timezone = this.me.timezone;

        try {
            this.bland_recording_data.transcription.messages.push({
                created_at: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
                is_bland: 1,
                // is_person: 1,
                message: self.new_ai_message,
                custom_name: this.respond_as
            });
        }
        catch (e) {

        }

        try {
            this.bland_transcription.messages.push({
                created_at: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
                is_bland: 1,
                // is_person: 1,
                message: self.new_ai_message,
                content: self.new_ai_message,
                custom_name: this.respond_as
            });
        }
        catch (e) {

        }

        this.sendingAiMessage = false;
        this.new_ai_message = "";

        try {
            setTimeout(function() {
                var objDiv = document.getElementById("ai-dialog-messages-list");
                objDiv.scrollTop = objDiv.scrollHeight;
            }, 10);
        }
        catch (e) {
        }

        try {
            setTimeout(function() {
                var objDiv = document.getElementById("chat-dialog-messages-list");
                objDiv.scrollTop = objDiv.scrollHeight;
            }, 10);
        }
        catch (e) {
        }
    },

    displaySpeakerTimestamp(milliseconds, firstItemMilliseconds) {
          //Get hours from milliseconds
          var hours = milliseconds / (1000*60*60);

          //if (firstItemMilliseconds < 1000)
            //hours = milliseconds / (100*60*60);

          var absoluteHours = Math.floor(hours);
          var h = absoluteHours > 9 ? absoluteHours : '0' + absoluteHours;

          //Get remainder from hours and convert to minutes
          var minutes = (hours - absoluteHours) * 60;
          var absoluteMinutes = Math.floor(minutes);
          var m = absoluteMinutes > 9 ? absoluteMinutes : '0' +  absoluteMinutes;

          //Get remainder from minutes and convert to seconds
          var seconds = (minutes - absoluteMinutes) * 60;
          var absoluteSeconds = Math.floor(seconds);
          var s = absoluteSeconds > 9 ? absoluteSeconds : '0' + absoluteSeconds;

          return h + ':' + m + ':' + s;
    },

    async showCallRailRecordingFunction(item) {
        if (this.me.is_medical) return false;

        let self = this;

        this.showCallRailRecording = true;
        this.loading_callrail_recording = true;

        this.lsa_item = item;
        
        this.callrail_recording_data.recording_url = item.call_rail_recording_url;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-callrail-transcript`, {
            lead_id: item.id
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.callrail_recording_data.transcription = response.data.transcription;
        this.loading_callrail_recording = false;

        setTimeout(function() {
            document.querySelector('#cr-audio-el-here').innerHTML = '<div class="mr-auto text-xs text-gray-600 pb-2">Recording Timestamp: ' + self.displayTimestamp(item.lead_creation_date) + '</div><audio onwindowresize="" controls="true" class="u-hide" src="' + self.callrail_recording_data.recording_url.replace('/recording', '/recording/redirect') + '" style="width: 100%"></audio>';
        }, 500);

        // <audio onwindowresize="" controls="true" class="u-hide" src="https://app.callrail.com/calls/CALbac64918f74f474fa45d6eb941ab371c/recording?access_key=1a62f6bf96da607431d2"></audio>
        // <audio onwindowresize="" controls="true" class="u-hide" src="https://app.callrail.com/calls/CAL3913e4104efd470a9303bc171e952ce8/recording/redirect?access_key=0f0a785d91552ee6ba6e"></audio>
    },

    async showBlandRecordingFunction(item) {
        if (this.me.is_medical) return false;

        this.ai_messages_lead = item;
        this.ai_messages_lead.show_ai_feedback = false;

        if (this.ai_messages_lead.ai_enabled == 1)
            this.ai_messages_lead.ai_enabled = true;
        else
            this.ai_messages_lead.ai_enabled = false;

        let self = this;

        this.showBlandRecording = true;
        this.loading_bland_recording = true;
        
        this.bland_recording_data.recording_url = item.bland_recording_url;
        this.bland_recording_data.sources = item.sources;
        this.bland_recording_data.lead_type = item.lead_type;
        this.bland_recording_data.id = item.id;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-bland-transcript`, {
            lead_id: item.id
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.bland_recording_data.transcription = response.data.transcription;

        let original_ai_messages = JSON.parse(JSON.stringify(this.bland_recording_data.transcription));
        original_ai_messages = original_ai_messages.messages;

        console.log('original_ai_messages', original_ai_messages);

        if (item.lead_type == "MESSAGE" && item.sources.indexOf('lsa') != -1) {
            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-messages`, {
                lead_id: item.id
            }, {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                }
            });

            for (var i in response.data.lsa_messages) {
                response.data.lsa_messages[i].sender = ((response.data.lsa_messages[i].participant_type == 3) ? "human" : "bot");
                response.data.lsa_messages[i].is_bland = ((response.data.lsa_messages[i].participant_type == 3) ? 0 : 1);
                // response.data.lsa_messages[i].is_person = 0;
                response.data.lsa_messages[i].timestamp = response.data.lsa_messages[i].event_time;
                response.data.lsa_messages[i].message = response.data.lsa_messages[i].text;

                for (var j in original_ai_messages) {
                    console.log('compare 1:', response.data.lsa_messages[i].message);
                    console.log('compare 2:', original_ai_messages[j].body);
                    if (response.data.lsa_messages[i].message == original_ai_messages[j].body) {

                        console.log("FOUD AI MESSAGE");
                        console.log(response.data.lsa_messages[i].message);
                        response.data.lsa_messages[i].is_person = 0;
                        break;
                    }
                }

                if (response.data.lsa_messages[i].text.indexOf('did you get my last message') != -1) {
                    response.data.lsa_messages[i].is_person = 0;
                }
            }

            this.bland_recording_data.transcription.messages = response.data.lsa_messages;
        }

        this.bland_recording_data.summary = response.data.summary;
        this.bland_recording_data.customer_name = item.customer_name;
        this.bland_recording_data.customer_email = item.customer_email;
        this.bland_recording_data.ai_provided_phone_number = item.ai_provided_phone_number;
        this.bland_recording_data.job_type = item.job_type;
        this.bland_recording_data.call_ended_by = item.call_ended_by;
        this.bland_recording_data.sentiment = response.data.sentiment;
        this.bland_recording_data.topics_discussed = response.data.topics_discussed;
        this.bland_recording_data.issues_raised = response.data.issues_raised;
        this.bland_recording_data.analysis = response.data.analysis;
        this.bland_recording_data.variables = response.data.variables;
        this.loading_bland_recording = false;

        if (response.data.recording_url)
            this.bland_recording_data.recording_url = response.data.recording_url;

        setTimeout(function() {
            if (self.bland_recording_data.recording_url) {
                document.querySelector('#bl-audio-el-here').innerHTML = '<div class="mr-auto text-xs text-gray-600 pb-2">Recording Timestamp: ' + self.displayTimestamp(item.lead_creation_date) + '</div><audio onwindowresize="" controls="true" class="u-hide" src="' + self.bland_recording_data.recording_url.replace(".mp3", ".wav") + '" style="width: 100%"></audio>';
            }
        }, 500);

        setTimeout(function() {
            var objDiv = document.getElementById("ai-dialog-messages-list");
            objDiv.scrollTop = objDiv.scrollHeight;
        }, 10);
    },

    async showLsaCallRecordings(item) {
        if (this.me.is_medical) return false;
        
        let self = this;

        console.log('this.lsa_item', this.lsa_item);

        this.showLsaRecordings = true;
        this.loading_lsa_recording = true;
        this.lsa_item = item;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-recordings`, {
            lead_id: item.id
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.loading_lsa_recordings = false;

        this.lsa_recording_data = JSON.parse(JSON.stringify(response.data));

        console.log('this.lsa_recording_data', this.lsa_recording_data);

        if (response.data.recordings.length > 0) {
            let recordings_html = '';

            for (var i in response.data.recordings) {
                recordings_html += '<div class="mr-auto text-xs text-gray-600 pb-2">Recording Timestamp: ' + self.displayTimestamp(item.lead_creation_date) + '</div><div style="margin-bottom: 15px;"><audio onwindowresize="" controls="true" class="u-hide" src="' + response.data.recordings[i] + '" style="width: 100%"></audio></div>';
            }

            setTimeout(function() {
                document.querySelector('#lsa-audio-el-here').innerHTML = recordings_html;
            }, 500);
        }
        else {
            document.querySelector('#lsa-audio-el-here').innerHTML = 'No recordings found.';
        }
    },

    async showLsaMessagesFunction(item) {
    
        // console.log('item.sources', item.sources)
        // console.log('itemplmmmm', item);

        // console.log(1);

        // console.log("item.sources.indexOf('bland')", item.sources.indexOf('bland'))

        if (item.sources.indexOf('bland') != -1) {
            console.log(2);
            this.showBlandRecordingFunction(item);
            return;
        }

        console.log(3);

        if (this.me.is_medical) return false;
        
        let self = this;

        this.showLsaMessages = true;
        this.loading_lsa_messages = true;
        this.lsa_messages_lead = item;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-messages`, {
            lead_id: item.id
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.loading_lsa_messages = false;

        this.lsa_messages_displayed = response.data.lsa_messages;
        this.loading_lsa_messages = false;
    },

    async showChatConversation(item) {
        if (this.me.is_medical) return false;
        
        let self = this;

        this.shouldShowChatConversation = true;
        this.loading_chat_conversation = true;
        this.ai_messages_lead = item;

        if (this.ai_messages_lead.ai_enabled == 1)
            this.ai_messages_lead.ai_enabled = true;
        else
            this.ai_messages_lead.ai_enabled = false;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-chat-conversation`, {
            lead_id: item.id
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.bland_transcription = response.data.transcription;
        this.loading_chat_conversation = false;

        setTimeout(function() {
            var objDiv = document.getElementById("chat-dialog-messages-list");
            objDiv.scrollTop = objDiv.scrollHeight;
        }, 10);
    },

    getCustomTagColor(tag) {
        for (var i in this.custom_tags) {
            if (this.custom_tags[i].tag == tag)
                return this.custom_tags[i].color;
        }

        return "";  
    },

    async archiveLead(item) {

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/archive-lead`, {
            id: item.id
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.getMessages(true);
    },

    async unArchiveLead(item) {

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/unarchive-lead`, {
            id: item.id
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.getMessages(true);
    },

    async saveAiFeedback(item) {
        this.savingAiFeedback = true;
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-ai-feedback`, {
            lead_id: item.id,
            ai_feedback: item.ai_feedback,
            ai_feedback_urgent: item.ai_feedback_urgent
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.savingAiFeedback = false;
        this.ai_messages_lead.show_ai_feedback = false;
        // this.showAddTag = false;
    },

    async saveTag() {
        this.savingTag = true;
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/save-tag`, {
            new_tag: this.new_tag,
            new_tag_color: this.new_tag_color
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.loadCustomTags();
        this.savingTag = false;
        this.showAddTag = false;
        this.new_tag = '';
        this.new_tag_color = '#000000';
    },

    async saveNote() {
        if (!this.new_note)
            return;

        this.savingNote = true;
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/add-note`, {
            lead_id: this.notes_lead.id,
            note: this.new_note
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.savingNote = false;
        this.notes_lead = response.data.lsa_lead;
        this.new_note = '';

        this.getMessages(true);
    },

    async deleteNote(index) {
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/delete-note`, {
            lead_id: this.notes_lead.id,
            note_index: index
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.notes_lead = response.data.lsa_lead;

        this.getMessages(true);
    },

    async loadCustomTags() {
        let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/load-custom-tags`, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.custom_tags = response.data.custom_tags;

        if (this.isOnlyAi()) {
            this.tags_items = [{
                    index: 0,
                    text: 'Not Set'
                },{
                    index: 1,
                    text: 'Existing Customer'
                },{
                    index: 2,
                    text: 'Missed Call'
                },{
                    index: 5,
                    text: 'Became Customer'
                },
                ,{
                    index: 'Cancelled',
                    text: 'Cancelled'
                }, 
                {
                    index: 'Complete',
                    text: 'Complete'
                }, {
                    index: 'Incomplete',
                    text: 'Incomplete'
                }, {
                    index: 'AI Test Call',
                    text: 'AI Test Call'
                },
            ]
        }
        else {
            this.tags_items = [{
                    index: 0,
                    text: 'Not Set'
                },{
                    index: 1,
                    text: 'Existing Customer'
                },{
                    index: 2,
                    text: 'Missed Call'
                },{
                    index: 3,
                    text: 'Opportunity'
                },{
                    index: 4,
                    text: 'Meeting Scheduled'
                },{
                    index: 5,
                    text: 'Became Customer'
                },{
                    index: 'Signed',
                    text: 'Signed'
                }
                ,{
                    index: 'Booked for Consultation',
                    text: 'Booked for Consultation'
                }
                ,{
                    index: 'Declined/Not a lead',
                    text: 'Declined/Not a lead'
                }
                ,{
                    index: 'Wrong Number',
                    text: 'Wrong Number'
                }
                ,{
                    index: 'Auto Credited',
                    text: 'Auto Credited'
                }
                ,{
                    index: 'No Response',
                    text: 'No Response'
                }
                ,{
                    index: 'Existing Client',
                    text: 'Existing Client'
                }
                ,{
                    index: 'Failed Sign Up',
                    text: 'Failed Sign Up'
                }
                ,{
                    index: 'Following Up/Working on this one',
                    text: 'Following Up/Working on this one'
                }
                ,{
                    index: 'E-Doc sent not signed',
                    text: 'E-Doc sent not signed'
                }
                ,{
                    index: 'Booked to Service',
                    text: 'Booked to Service'
                }
                ,{
                    index: 'Booked for Appointment',
                    text: 'Booked for Appointment'
                }
                ,{
                    index: 'Cancelled',
                    text: 'Cancelled'
                }, 
                {
                    index: 'Complete',
                    text: 'Complete'
                }, {
                    index: 'Incomplete',
                    text: 'Incomplete'
                }, {
                    index: 'AI Test Call',
                    text: 'AI Test Call'
                }, {
                    index: 'Duplicate Call',
                    text: 'Duplicate Call'
                },
            ]
        }

        for (var i in this.custom_tags) {
            this.tags_items.push({
                index: this.custom_tags[i].tag,
                text: this.custom_tags[i].tag
            });
        }
    },

    getCustomStatusColor(status) {
        for (var i in this.custom_statuses) {
            if (this.custom_statuses[i].status == status)
                return this.custom_statuses[i].color;
        }

        return "";  
    },
    async saveStatus() {
        this.savingStatus = true;
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/save-status`, {
            new_status: this.new_status,
            new_status_color: this.new_status_color
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.loadCustomStatuses();
        this.savingStatus = false;
        this.showAddStatus = false;
        this.new_status = '';
        this.new_status_color = '#000000';
    },

    async loadCustomStatuses() {
        let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/load-custom-statuses`, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.custom_statuses = response.data.custom_statuses;

        this.qualify_status_items = [{
            index: 0,
            text: 'Not Set'
        },{
            index: 1,
            text: 'Qualified'
        },{
            index: -1,
            text: 'Unqualified'
        },{
            index: 2,
            text: 'Spam'
        }]

        for (var i in this.custom_statuses) {
            this.qualify_status_items.push({
                index: this.custom_statuses[i].status,
                text: this.custom_statuses[i].status
            });
        }
    },

    formatDate: function(date, format = "MM/DD/YYYY") {
        return moment(String(date)).format(format)
    },

    displayTimestamp(date) {
        let timezone = this.me.timezone;

        // .tz(timezone)
        return moment.utc(date).format('ddd M/D YYYY h:mm:ss A');
    },

    displayDuration(seconds) {
        return date;
    },

    displayDuration(time) {
        var sec_num = time // don't forget the second param
        var hours   = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num - (hours * 3600) - (minutes * 60);

        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        return hours+':'+minutes+':'+seconds;
    },

    formatPhoneNumber(phoneNumberString) {
        const match = phoneNumberString
.replace(/\D+/g, '').replace(/^1/, '')
.match(/([^\d]*\d[^\d]*){1,10}$/)[0]
const part1 = match.length > 2 ? `(${match.substring(0,3)})` : match
const part2 = match.length > 3 ? ` ${match.substring(3, 6)}` : ''
const part3 = match.length > 6 ? `-${match.substring(6, 10)}` : ''    
return `${part1}${part2}${part3}`
    },

    playAudio(item) {
        if (document.getElementById('audio-element-wrapper-' + item.id).style.display == 'none') {
            let elements = document.getElementsByClassName('audio-element-wrapper');

            for (var i in elements) {
                try {
                    elements[i].style.display = 'none';
                }
                catch (e) {}
            }

            let elements2 = document.getElementsByClassName('audio-element');

            for (var i in elements) {
                try {
                    elements2[i].pause();
                    elements2[i].currentTime = 0;
                }
                catch (e) {}
            }

            let elements3 = document.getElementsByClassName('audio-element-icon');

            for (var i in elements) {
                try {
                    elements3[i].style.display = 'block';
                }
                catch (e) {}
            }

            document.getElementById('audio-element-wrapper-' + item.id).style.display = 'block';
            document.getElementById('audio-element-' + item.id).play();

            document.getElementById('audio-element-icon-' + item.id).style.display = 'none';

            
        }
        else {
            document.getElementById('audio-element-wrapper-' + item.id).style.display = 'none';
            document.getElementById('audio-element-' + item.id).pause();
            document.getElementById('audio-element-' + item.id).currentTime = 0;

            document.getElementById('audio-element-icon-' + item.id).style.display = 'block';
        }
    },

    showEditValue(item) {
        $('.lsa-show-value-' + item.id).hide();
        $('.lsa-edit-value-' + item.id).show();
        setTimeout(function() {
            $('.lsa-edit-value-' + item.id).focus();
        }, 20);
    },

    cancelEditValue(item) {
        $('.lsa-show-value-' + item.id).show();
        $('.lsa-edit-value-' + item.id).hide();
    },

    async editValue(item) {
        item.value = $('.lsa-edit-value-' + item.id + ' input').val();
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/edit-value-message`, {
            item: item
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.leadDetailsMobile = response.data.lead; this.showFullLeadDetailsMobileKey++;
        this.getMessages(true);

        $('.lsa-show-value').show();
        $('.lsa-edit-value').hide();
    },

    showEditCustomerName(item) {
        $('.lsa-show-customer-name-' + item.id).hide();
        $('.lsa-edit-customer-name-' + item.id).show();
        setTimeout(function() {
            $('.lsa-edit-customer-name-' + item.id).focus();
        }, 20);
    },

    cancelEditCustomerName(item) {
        $('.lsa-show-customer-name-' + item.id).show();
        $('.lsa-edit-customer-name-' + item.id).hide();
    },

    async editCustomerName(item) {
        item.customer_name = $('.lsa-edit-customer-name-' + item.id + ' input').val();
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/edit-customer-name`, {
            item: item
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.getMessages(true);

        $('.lsa-show-customer-name').show();
        $('.lsa-edit-customer-name').hide();
    },

    showEditAddress(item) {
        $('.lsa-show-address-' + item.id).hide();
        $('.lsa-edit-address-' + item.id).show();
        setTimeout(function() {
            $('.lsa-edit-address-' + item.id).focus();
        }, 20);
    },

    cancelEditAddress(item) {
        $('.lsa-show-address-' + item.id).show();
        $('.lsa-edit-address-' + item.id).hide();
    },

    async editAddress(item) {
        item.address = $('.lsa-edit-address-' + item.id + ' input').val();
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/edit-address`, {
            item: item
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.getMessages(true);

        $('.lsa-show-address').show();
        $('.lsa-edit-address').hide();
    },

    filterDate() {
        console.log(this.date_filter.length);
        if (!this.date_filter[1])
            return;

        this.show_picker = false;
        this.getMessages();
    },

      applyDate(selected_date) {
        this.all_time = 0;
        // console.log('selected_date', selected_date);
        this.selected_date_text = selected_date;
        switch (selected_date) {
          case 'This Week':
            this.date_filter[0] = moment().startOf('week').format('YYYY-MM-DD');
            this.date_filter[1] = moment().endOf('week').format('YYYY-MM-DD');
          break;
          case 'Last Week':
            this.date_filter[0] = moment().startOf('week').subtract(7, 'days').format('YYYY-MM-DD');
            this.date_filter[1] = moment().endOf('week').subtract(7, 'days').format('YYYY-MM-DD');
          break;
          case 'This Month':
            this.date_filter[0] = moment().startOf('month').format('YYYY-MM-DD');
            this.date_filter[1] = moment().endOf('month').format('YYYY-MM-DD');
          break;
          case 'Last Month':
            this.date_filter[0] = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
            this.date_filter[1] = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
          break;
          case 'Last 60 days':
            this.date_filter[0] = moment().subtract(60, 'days').format('YYYY-MM-DD');
            this.date_filter[1] = moment().format('YYYY-MM-DD');
          break;
          case 'Last 90 days':
            this.date_filter[0] = moment().subtract(90, 'days').format('YYYY-MM-DD');
            this.date_filter[1] = moment().format('YYYY-MM-DD');
          break;
          case 'This Year':
            this.date_filter[0] = moment().startOf('year').format('YYYY-MM-DD');
            this.date_filter[1] = moment().endOf('year').format('YYYY-MM-DD');
          break;
          case 'Last Year':
            this.date_filter[0] = moment().startOf('year').subtract(1, 'year').format('YYYY-MM-DD');
            this.date_filter[1] = moment().endOf('year').subtract(1, 'year').format('YYYY-MM-DD');
          break;

          case 'All Time':
            this.date_filter[0] = moment().startOf('year').subtract(10, 'years').format('YYYY-MM-DD');
            this.date_filter[1] = moment().format('YYYY-MM-DD');
            
            this.all_time = 1;
          break;
        }
        // console.log(this.date_filter);
        this.show_picker = false;
        this.getMessages();
      },

    async getMessages(silent = false) {
        let self = this;

        if (!silent)
            this.loading = true;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-messages`, {
            date_filter: this.date_filter,
            search: this.search,
            tag: this.tag,
            qualify_status: this.qualify_status,
            archived_filter: this.archived_filter,
            channel_filter: this.channel_filter,
            lead_type_filter: this.lead_type_filter,
            charge_status_filter: this.charge_status_filter
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        })

        this.messages = response.data.messages;
        this.lsa_leads_count = response.data.lsa_leads_count;
        this.ai_leads_count = response.data.ai_leads_count;
        this.ai_leads_count_msg = response.data.ai_leads_count_msg;
        this.ai_leads_count_voice = response.data.ai_leads_count_voice;
        this.callrail_leads_count = response.data.callrail_leads_count;
        this.converted_leads_count = response.data.converted_leads_count;
        this.converted_ai_leads_count = response.data.converted_ai_leads_count;
        this.converted_human_leads_count = response.data.converted_human_leads_count;
        this.booked_leads_count = response.data.booked_leads_count;
        this.booked_ai_leads_count = response.data.booked_ai_leads_count;
        this.booked_human_leads_count = response.data.booked_human_leads_count;
        this.loading = false;

        if (this.$route.query.tconv) {
            // https://organic-train-7vqj4qq9x9hrgp5-8080.app.github.dev/login?alt=ZXlKMGVYQWlPaUpLVjFRaUxDSmhiR2NpT2lKSVV6STFOaUo5LmV5SnBjM01pT2lKb2RIUndjenBjTDF3dmJITmhMbkpoZG5VdWJXVmNMM1JqYjI1Mklpd2lhV0YwSWpveE56TXdORFkwT1RFeUxDSmxlSEFpT2pFM016RXdOamszTVRJc0ltNWlaaUk2TVRjek1EUTJORGt4TWl3aWFuUnBJam9pYW1WM1pHZE9Xa2htUmt0aWNVMHlUQ0lzSW5OMVlpSTZNVEF6TXl3aWNISjJJam9pTWpOaVpEVmpPRGswT1dZMk1EQmhaR0l6T1dVM01ERmpOREF3T0RjeVpHSTNZVFU1TnpabU55SjkueU5PbmtGUlFmaWZ6YlI2MzBmYlRhZ1Y0bHp5MW12QWtCNXpSNVlROHdoMA==&redirect=%2Fleads%3Ftconv%3D162368

            // this.showBlandRecording = showBlandRecordingFunction(item);

            tryClick();

            function tryClick() {
                try {
                    console.log('trying...');
                    document.querySelector("#sblrcfncc-" + this.$route.query.tconv).click();
                }
                catch(e) {
                    setTimeout(function() {
                        tryClick();
                    }, 100);
                }
            }
        }
    },

    async setTag(item, tag) {
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-tag-message`, {
            message_id: item.id,
            tag: tag
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        })

        this.leadDetailsMobile = response.data.lead; this.showFullLeadDetailsMobileKey++;
        this.getMessages(true);
    },

    async removeTag(item, tag) {
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/remove-tag-message`, {
            message_id: item.id,
            tag: tag
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        })

        this.leadDetailsMobile = response.data.lead; this.showFullLeadDetailsMobileKey++;
        this.getMessages(true);
    },

    async setQualifyStatus(item, qualify_status) {
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-qualify-status-message`, {
            message_id: item.id,
            qualify_status: qualify_status
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        })

        this.leadDetailsMobile = response.data.lead; this.showFullLeadDetailsMobileKey++;
        this.getMessages(true);
    },

    getMonthlyReport() {
        window.open('/leads-public-survey/' + this.me.uuid);
    },

    async sendMonthlyReport(item, qualify_status) {
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/send-monthly-survey-report`, {
            now: 2
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        })

        this.$swal({
            title: "Email sent!",
            text: "The report has been successfully sent to the customer!",
            showCancelButton: false,
        });
    },

    downloadCsv() {
        this.exporting = true;

        let self = this;

        let csv = 'Customer, Timestamp, Lead Type, Sources, Charge Status, Survey Score, Survey Notes, Intake Score, Intake Notes, AI Score, AI Rating\n';
        this.messages.forEach((row) => {

            let customer = "";

            if (row.job_type) {
                customer = row.job_type + " - ";
            }

            if (row.customer_phone_number) {
                customer += row.customer_phone_number;
            }

            let tags = [];

            for (var i in row.tag) {
                for (var j in this.tags_items) {
                    if (this.tags_items[j].index == row.tag[i]) {
                        tags.push(this.tags_items[j].text);
                    }
                }
            }

            let lead_status = "Not Set";

            switch (row.qualify_status) {
                case 1:
                    lead_status = 'Qualified';
                break;
                case -1:
                    lead_status = 'Unqualified';
                break;
                case 2:
                    lead_status = 'Spam';
                break;
            }

            if (row.qualify_status != 0 && row.qualify_status != 1 && row.qualify_status != 2 && row.qualify_status != -1) {
                lead_status = row.qualify_status;
            }

            let survey_score = "N/A";
            let survey_notes = "N/A";
            let intake_score = "N/A";
            let intake_notes = "N/A";
            let ai_score = "N/A";
            let ai_notes = "N/A";

            if (row.rated_at) {
                survey_score = self.convertSatisfactionToNumber(row.satisfaction);

                survey_notes = row.summary || row.additional_comments;
            }

            if (row.intake_performance) {
                intake_score = row.intake_performance.rating;
                intake_notes = row.intake_performance.explanation;
            }

            if (row.ai_performance) {
                ai_score = row.ai_performance.rating;
                ai_notes = row.ai_performance.explanation;
            }

            let csv_data = [
                '"' + customer + '"',
                '"' + self.displayTimestamp(row.lead_creation_date) + '"',
                '"' + row.lead_type + '"',
                '"' + row.sources.replace('bland', 'AI') + '"',
                // '"' + tags.join(",") + '"',
                '"' + row.charge_status + '"',
                '"' + survey_score + '"',
                '"' + survey_notes + '"',
                '"' + intake_score + '"',
                '"' + intake_notes + '"',
                '"' + ai_score + '"',
                '"' + ai_notes + '"'
            ]

            csv += csv_data.join(',');
            csv += "\n";
        });

        csv = csv.replace(/null/g, "");
    
        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
        anchor.target = '_blank';
        anchor.download = 'calls-' + this.date_filter.join("-") + ".csv";
        anchor.click();

        this.exporting = false;
    },

    convertSatisfactionToNumber(value) {
        const map = {
            "VERY_SATISFIED": 5,
            "SATISFIED": 4,
            "NEUTRAL": 3,
            "DISSATISFIED": 2,
            "VERY_DISSATISFIED": 1
        };
        return map[value] || 'Not Set';
    },

    async doCreated() {
        if (!this.me)
            await this.$store.dispatch('me/fetch')

        let self = this
        await self.getMessages();
        self.loadCustomTags();
        self.loadCustomStatuses();

        this.respond_as = this.profile.first_name;

        // this.thisProc = setInterval(function() {
        //     self.getMessages(true);
        // }, 5000);

        console.log('do this');
        // Trigger for only items that have no AI suggestion yet
    },

    onTableOptionsChange(options) {
        const start = (options.page - 1) * options.itemsPerPage;
        const end = start + options.itemsPerPage;

        const visibleItems = this.messages.slice(start, end);

        console.log('visibleItems', visibleItems)

        visibleItems
          .filter(item => !item.rated_at && !this.aiSuggestionById[item.id])
          .forEach(item => this.generateAiSuggestion(item));
      },

      generateVisibleSuggestions(items) {
          items.forEach(item => {
            if (!item.rated_at && !this.requestedSuggestions.has(item.id)) {
              this.requestedSuggestions.add(item.id);
              this.generateAiSuggestion(item);
            }
          });
      }
},

destroyed() {
    clearTimeout(this.thisProc);
    this.thisProc = null;
},

created() {
    console.log("DO CREATED");
    this.doCreated();
},
  watch: {
    selected: {
      handler() {
        this.selectedIds = [];
        this.selectedPhoneNumbers = [];

        for (var i in this.selected) {
            if (this.selected[i].bland_sid) {
                this.selectedIds.push(this.selected[i].bland_sid);
            }

            if (this.selected[i].customer_phone_number) {
                this.selectedPhoneNumbers.push(this.selected[i].customer_phone_number);
            }
        }
      }
    }
  },
}
</script>


<style scoped>
.intake-tooltip {
  max-width: 320px;
  white-space: normal;
  word-wrap: break-word;
  line-height: 1.4;
}

/* Normalize icon look/feel so they don't jump around across rows */
.rg-channel-icon {
    width: 22px;
    height: 22px;
    display: inline-block;
    object-fit: contain;
}

.custom-text-field .v-input__control input {
border-color: white !important;
}

.v-text-field--outlined fieldset {
border: 1px solid red;
}
.header-inputs {
border-color: white !important;
}

.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
color: rgba(0, 0, 0, 0.38);
border-color: white !important;
}

.v-text-field--outlined fieldset {
border: 1px solid white !important;
}

.status-chip {
font-weight: bold;
text-transform: uppercase;
}

.status-Qualified {
color: green !important;
border-color: green !important;

}

.status-inQualified {
color: red;
border-color: red;
}

.custom-badge {
background-color: rgba(0, 230, 130, 0.1) !important;
color: #09ad95 !important;
}

.tags {
color: #e0e0e0;
font-size: small;
padding-left: 5px;

}

.icon-container {
display: flex;
align-items: center;
justify-content: center;
width: 48px;
height: 48px;
border-radius: 50%;
border: 2px solid #ccc;
cursor: pointer;
}

.icon {
font-size: 24px;
}

textarea:focus, input:focus{
    outline: none;
}

.stats-btn .stats-div {
    display: none;
}

.stats-btn:hover .stats-div {
    display: block;
}
</style>